import { Notify as _e, useQuasar as pe, QForm as Ce, QInput as te, QMenu as nt, QList as st, QItem as at, QItemSection as rt, QSelect as oo, QBtn as Y, QDialog as Re, QPopupProxy as Ct, QDate as kt, ClosePopup as Et, QIcon as St, QCheckbox as ye, QCard as no, QCardSection as so, Quasar as ao, Loading as it } from "quasar";
import { computed as ue, shallowRef as Tt, isRef as qe, watch as Ae, shallowReadonly as ro, toValue as ce, getCurrentScope as io, onScopeDispose as lo, readonly as Lt, toRef as co, ref as T, customRef as uo, reactive as we, unref as i, onMounted as ke, inject as me, createElementBlock as H, openBlock as $, createElementVNode as _, mergeModels as be, useModel as Oe, createBlock as F, withModifiers as Z, withCtx as w, createVNode as b, toDisplayString as q, withKeys as ie, createSlots as $t, Fragment as Ue, renderList as lt, createTextVNode as K, useTemplateRef as ge, createCommentVNode as ne, nextTick as Pt, resolveComponent as G, withDirectives as Ne, normalizeClass as Fe, provide as Rt, mergeProps as Vt, TransitionGroup as xt, resolveDirective as Mt, defineCustomElement as Be } from "vue";
import { createI18n as fo, useI18n as fe, I18nInjectionKey as je } from "vue-i18n";
import { parsePhoneNumberWithError as po, parsePhoneNumberFromString as mo } from "libphonenumber-js";
const vo = {
  login: {
    title: "Login or Register",
    phoneRegisterTitle: "Mobile phone number registration",
    or: "or",
    benefits: {
      birthday: "Birthday Gift",
      points: "Rewards Points",
      freeGift: "Redeem Free Gifts"
    },
    form: {
      continue: "Continue",
      labelMobile: "Mobile phone",
      labelEmailOrMobile: "E-mail or Mobile phone",
      labelEmail: "E-mail",
      validateRequired: "Please enter your email or phone number",
      validatePhone: "Please enter your correct phone number",
      validateEmail: "Please enter your correct email address",
      validateEmailRequired: "Please enter your email"
    },
    actions: {
      change: "Change",
      signIn: "Sign in",
      createAccount: "Create account",
      forgotPassword: "Forgot password"
    },
    switch: {
      codeLogin: "Verification code login",
      passwordLogin: "Password login"
    },
    code: {
      label: "Verification code",
      send: "Send",
      errorSendFail: "Failed to send verification code",
      errorSessionExpired: "The session has expired and needs to be restarted",
      errorIncorrect: "The verification code is incorrect",
      validateRequired: "Please enter the verification code",
      validateLength: "Please enter the correct verification code"
    },
    password: {
      label: "Password",
      validateRequired: "Please enter your password",
      validateLength: "Please enter a 6-digit password",
      errorIncorrect: "Password error, please re-enter"
    },
    birthday: {
      label_html: "Child's Birthday / Due Date",
      placeholder_html: "Child's Birthday / Due Date",
      validateRequired_html: "Please enter your child's birthday / due date",
      validateInvalid_html: "Please enter your current Child's Birthday / Due Date"
    },
    newsletter: {
      labelEmail: "I agree to receive notifications and updates via email",
      labelPhone: "I agree to receive notifications and updates via my phone number"
    },
    common: {
      close: "Close",
      unknownError: "Unknown error",
      confirm: "Confirm"
    },
    account: {
      existsPhone: "The phone number has been registered, please change it",
      existsEmail: "The email has been registered, please change it"
    },
    terms: {
      full: "By selecting create account you agree to our {privacy} and {terms}",
      privacy: "Privacy Policy",
      terms_html: "Terms & Conditions",
      validateRequired: "Please agree to the terms to continue",
      policyInfo: "I agree to the {privacy} and {terms} and acknowledge that providing my email and phone number is required for account management.",
      policyTip_html: "<div style='text-align:center'>Please read and agree to the Terms of Service <br>and Privacy Policy first.</div>"
    },
    country: {
      us: "United States",
      ca: "Canada"
    }
  }
}, go = {
  default: {
    ...vo,
    ...window?.__MOMCOZY_LOGIN_I18N__ || {}
  }
}, de = fo({
  locale: "default",
  legacy: !1,
  escapeParameterHtml: !0,
  messages: go
}), yo = "momcozy-token";
function ct() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName ? window.__MC__CONFIG__.cookieName : yo;
}
function ho(e) {
  const s = document.cookie.split(";").find((a) => a.trim().startsWith(`${e}=`));
  return s ? s.trim().substring(e.length + 1) : null;
}
function wo(e, t, s = 7, a = window.location.hostname) {
  const r = new Date(Date.now() + s * 24 * 60 * 60 * 1e3).toUTCString();
  document.cookie = `${e}=${t}; expires=${r}; path=/; domain=${a}; SameSite=Lax`;
}
function bo(e, t = window.location.hostname) {
  document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${t}; SameSite=Lax`;
}
function ut(e) {
  const t = ct();
  wo(t, e);
}
function He() {
  if (window.__MC__CONFIG__ && window.__MC__CONFIG__.token)
    return window.__MC__CONFIG__.token;
  const e = ct();
  return ho(e);
}
function It() {
  const e = ct();
  bo(e);
}
class _o extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:EXPIRED", { detail: t });
  }
}
let Co = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}, ko = class extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
};
class Eo extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:HIDE", { detail: t });
  }
}
function qt(e) {
  document.body.classList.remove("momcozy-logined"), document.dispatchEvent(new _o(e));
}
const So = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, To = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, Lo = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $o(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    Po(e);
    return;
  }
  return t;
}
function Po(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function At(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const s = e.trim();
  if (s.length <= 9)
    switch (s.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!Lo.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (So.test(e) || To.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, $o);
    }
    return JSON.parse(e);
  } catch (a) {
    if (t.strict)
      throw a;
    return e;
  }
}
const Ro = /#/g, Vo = /&/g, xo = /\//g, Mo = /=/g, dt = /\+/g, Io = /%5e/gi, qo = /%60/gi, Ao = /%7c/gi, Oo = /%20/gi;
function Uo(e) {
  return encodeURI("" + e).replace(Ao, "|");
}
function et(e) {
  return Uo(typeof e == "string" ? e : JSON.stringify(e)).replace(dt, "%2B").replace(Oo, "+").replace(Ro, "%23").replace(Vo, "%26").replace(qo, "`").replace(Io, "^").replace(xo, "%2F");
}
function Ke(e) {
  return et(e).replace(Mo, "%3D");
}
function Ot(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function No(e) {
  return Ot(e.replace(dt, " "));
}
function Fo(e) {
  return Ot(e.replace(dt, " "));
}
function Bo(e = "") {
  const t = /* @__PURE__ */ Object.create(null);
  e[0] === "?" && (e = e.slice(1));
  for (const s of e.split("&")) {
    const a = s.match(/([^=]+)=?(.*)/) || [];
    if (a.length < 2)
      continue;
    const r = No(a[1]);
    if (r === "__proto__" || r === "constructor")
      continue;
    const l = Fo(a[2] || "");
    t[r] === void 0 ? t[r] = l : Array.isArray(t[r]) ? t[r].push(l) : t[r] = [t[r], l];
  }
  return t;
}
function jo(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map(
    (s) => `${Ke(e)}=${et(s)}`
  ).join("&") : `${Ke(e)}=${et(t)}` : Ke(e);
}
function Ho(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => jo(t, e[t])).filter(Boolean).join("&");
}
const Do = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, Go = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, Zo = /^([/\\]\s*){2,}[^/\\]/, Qo = /^\.?\//;
function Ut(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? Do.test(e) : Go.test(e) || (t.acceptRelative ? Zo.test(e) : !1);
}
function zo(e = "", t) {
  return e.endsWith("/");
}
function Xo(e = "", t) {
  return (zo(e) ? e.slice(0, -1) : e) || "/";
}
function Yo(e = "", t) {
  return e.endsWith("/") ? e : e + "/";
}
function Nt(e, t) {
  if (Ko(t) || Ut(e))
    return e;
  const s = Xo(t);
  return e.startsWith(s) ? e : Jo(s, e);
}
function Ft(e, t) {
  const s = en(e), a = { ...Bo(s.search), ...t };
  return s.search = Ho(a), tn(s);
}
function Ko(e) {
  return !e || e === "/";
}
function Wo(e) {
  return e && e !== "/";
}
function Jo(e, ...t) {
  let s = e || "";
  for (const a of t.filter((r) => Wo(r)))
    if (s) {
      const r = a.replace(Qo, "");
      s = Yo(s) + r;
    } else
      s = a;
  return s;
}
const Bt = Symbol.for("ufo:protocolRelative");
function en(e = "", t) {
  const s = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (s) {
    const [, y, C = ""] = s;
    return {
      protocol: y.toLowerCase(),
      pathname: C,
      href: y + C,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!Ut(e, { acceptRelative: !0 }))
    return yt(e);
  const [, a = "", r, l = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, c = "", n = ""] = l.match(/([^#/?]*)(.*)?/) || [];
  a === "file:" && (n = n.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: u, search: d, hash: o } = yt(n);
  return {
    protocol: a.toLowerCase(),
    auth: r ? r.slice(0, Math.max(0, r.length - 1)) : "",
    host: c,
    pathname: u,
    search: d,
    hash: o,
    [Bt]: !a
  };
}
function yt(e = "") {
  const [t = "", s = "", a = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: s,
    hash: a
  };
}
function tn(e) {
  const t = e.pathname || "", s = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", a = e.hash || "", r = e.auth ? e.auth + "@" : "", l = e.host || "";
  return (e.protocol || e[Bt] ? (e.protocol || "") + "//" : "") + r + l + t + s + a;
}
let on = class extends Error {
  constructor(t, s) {
    super(t, s), this.name = "FetchError", s?.cause && !this.cause && (this.cause = s.cause);
  }
};
function nn(e) {
  const t = e.error?.message || e.error?.toString() || "", s = e.request?.method || e.options?.method || "GET", a = e.request?.url || String(e.request) || "/", r = `[${s}] ${JSON.stringify(a)}`, l = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", c = `${r}: ${l}${t ? ` ${t}` : ""}`, n = new on(
    c,
    e.error ? { cause: e.error } : void 0
  );
  for (const u of ["request", "options", "response"])
    Object.defineProperty(n, u, {
      get() {
        return e[u];
      }
    });
  for (const [u, d] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(n, u, {
      get() {
        return e.response && e.response[d];
      }
    });
  return n;
}
const sn = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function ht(e = "GET") {
  return sn.has(e.toUpperCase());
}
function an(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer || e instanceof FormData || e instanceof URLSearchParams ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const rn = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), ln = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function cn(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return ln.test(t) ? "json" : t === "text/event-stream" ? "stream" : rn.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function un(e, t, s, a) {
  const r = dn(
    t?.headers ?? e?.headers,
    s?.headers,
    a
  );
  let l;
  return (s?.query || s?.params || t?.params || t?.query) && (l = {
    ...s?.params,
    ...s?.query,
    ...t?.params,
    ...t?.query
  }), {
    ...s,
    ...t,
    query: l,
    params: l,
    headers: r
  };
}
function dn(e, t, s) {
  if (!t)
    return new s(e);
  const a = new s(t);
  if (e)
    for (const [r, l] of Symbol.iterator in e || Array.isArray(e) ? e : new s(e))
      a.set(r, l);
  return a;
}
async function Ee(e, t) {
  if (t)
    if (Array.isArray(t))
      for (const s of t)
        await s(e);
    else
      await t(e);
}
const fn = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), pn = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function jt(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: s = globalThis.Headers,
    AbortController: a = globalThis.AbortController
  } = e;
  async function r(n) {
    const u = n.error && n.error.name === "AbortError" && !n.options.timeout || !1;
    if (n.options.retry !== !1 && !u) {
      let o;
      typeof n.options.retry == "number" ? o = n.options.retry : o = ht(n.options.method) ? 0 : 1;
      const y = n.response && n.response.status || 500;
      if (o > 0 && (Array.isArray(n.options.retryStatusCodes) ? n.options.retryStatusCodes.includes(y) : fn.has(y))) {
        const C = typeof n.options.retryDelay == "function" ? n.options.retryDelay(n) : n.options.retryDelay || 0;
        return C > 0 && await new Promise((p) => setTimeout(p, C)), l(n.request, {
          ...n.options,
          retry: o - 1
        });
      }
    }
    const d = nn(n);
    throw Error.captureStackTrace && Error.captureStackTrace(d, l), d;
  }
  const l = async function(u, d = {}) {
    const o = {
      request: u,
      options: un(
        u,
        d,
        e.defaults,
        s
      ),
      response: void 0,
      error: void 0
    };
    if (o.options.method && (o.options.method = o.options.method.toUpperCase()), o.options.onRequest && (await Ee(o, o.options.onRequest), o.options.headers instanceof s || (o.options.headers = new s(
      o.options.headers || {}
      /* compat */
    ))), typeof o.request == "string" && (o.options.baseURL && (o.request = Nt(o.request, o.options.baseURL)), o.options.query && (o.request = Ft(o.request, o.options.query), delete o.options.query), "query" in o.options && delete o.options.query, "params" in o.options && delete o.options.params), o.options.body && ht(o.options.method))
      if (an(o.options.body)) {
        const p = o.options.headers.get("content-type");
        typeof o.options.body != "string" && (o.options.body = p === "application/x-www-form-urlencoded" ? new URLSearchParams(
          o.options.body
        ).toString() : JSON.stringify(o.options.body)), p || o.options.headers.set("content-type", "application/json"), o.options.headers.has("accept") || o.options.headers.set("accept", "application/json");
      } else // ReadableStream Body
      ("pipeTo" in o.options.body && typeof o.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof o.options.body.pipe == "function") && ("duplex" in o.options || (o.options.duplex = "half"));
    let y;
    if (!o.options.signal && o.options.timeout) {
      const p = new a();
      y = setTimeout(() => {
        const v = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        v.name = "TimeoutError", v.code = 23, p.abort(v);
      }, o.options.timeout), o.options.signal = p.signal;
    }
    try {
      o.response = await t(
        o.request,
        o.options
      );
    } catch (p) {
      return o.error = p, o.options.onRequestError && await Ee(
        o,
        o.options.onRequestError
      ), await r(o);
    } finally {
      y && clearTimeout(y);
    }
    if ((o.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    o.response._bodyInit) && !pn.has(o.response.status) && o.options.method !== "HEAD") {
      const p = (o.options.parseResponse ? "json" : o.options.responseType) || cn(o.response.headers.get("content-type") || "");
      switch (p) {
        case "json": {
          const v = await o.response.text(), x = o.options.parseResponse || At;
          o.response._data = x(v);
          break;
        }
        case "stream": {
          o.response._data = o.response.body || o.response._bodyInit;
          break;
        }
        default:
          o.response._data = await o.response[p]();
      }
    }
    return o.options.onResponse && await Ee(
      o,
      o.options.onResponse
    ), !o.options.ignoreResponseError && o.response.status >= 400 && o.response.status < 600 ? (o.options.onResponseError && await Ee(
      o,
      o.options.onResponseError
    ), await r(o)) : o.response;
  }, c = async function(u, d) {
    return (await l(u, d))._data;
  };
  return c.raw = l, c.native = (...n) => t(...n), c.create = (n = {}, u = {}) => jt({
    ...e,
    ...u,
    defaults: {
      ...e.defaults,
      ...u.defaults,
      ...n
    }
  }), c;
}
const Ve = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})(), mn = Ve.fetch ? (...e) => Ve.fetch(...e) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), vn = Ve.Headers, gn = Ve.AbortController, yn = jt({ fetch: mn, Headers: vn, AbortController: gn });
function ft() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl ? window.__MC__CONFIG__.apiUrl : "https://account.momcozy.com";
}
function De(e) {
  const s = new TextEncoder().encode(e);
  let a = "";
  for (let r = 0; r < s.length; r++)
    a += String.fromCharCode(s[r]);
  return btoa(a);
}
function hn() {
  return window.__MC__CONFIG__ && window.__MC__CONFIG__.headers ? window.__MC__CONFIG__.headers : {
    "X-STORE-CODE": "MOMCOZY_US"
  };
}
const wn = ft(), xe = yn.create({
  baseURL: wn,
  onRequest({ options: e }) {
    const t = He();
    e.headers = {
      ...e.headers,
      authorization: `Bearer ${t}`
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && qt(t), t && Reflect.has(t, "result") && (e._data = t.result));
  }
});
xe.get = (e, t) => xe(e, { method: "GET", ...t });
xe.post = (e, t) => xe(e, { method: "POST", ...t });
const pt = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i, Ht = "https://app.cozyinnov.com/app/privacy";
class bn extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:LOGIN", { detail: t });
  }
}
class _n extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:CLOSE", { detail: t });
  }
}
class Me extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:THIRD-LOGIN:SUCCESS", { detail: t });
  }
}
class Cn extends Error {
  constructor(t, s) {
    super(t, s), this.name = "FetchError", s?.cause && !this.cause && (this.cause = s.cause);
  }
}
function kn(e) {
  const t = e.error?.message || e.error?.toString() || "", s = e.request?.method || e.options?.method || "GET", a = e.request?.url || String(e.request) || "/", r = `[${s}] ${JSON.stringify(a)}`, l = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", c = `${r}: ${l}${t ? ` ${t}` : ""}`, n = new Cn(
    c,
    e.error ? { cause: e.error } : void 0
  );
  for (const u of ["request", "options", "response"])
    Object.defineProperty(n, u, {
      get() {
        return e[u];
      }
    });
  for (const [u, d] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(n, u, {
      get() {
        return e.response && e.response[d];
      }
    });
  return n;
}
const En = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function wt(e = "GET") {
  return En.has(e.toUpperCase());
}
function Sn(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const Tn = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), Ln = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function $n(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return Ln.test(t) ? "json" : Tn.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function Pn(e, t, s, a) {
  const r = Rn(
    t?.headers ?? e?.headers,
    s?.headers,
    a
  );
  let l;
  return (s?.query || s?.params || t?.params || t?.query) && (l = {
    ...s?.params,
    ...s?.query,
    ...t?.params,
    ...t?.query
  }), {
    ...s,
    ...t,
    query: l,
    params: l,
    headers: r
  };
}
function Rn(e, t, s) {
  if (!t)
    return new s(e);
  const a = new s(t);
  if (e)
    for (const [r, l] of Symbol.iterator in e || Array.isArray(e) ? e : new s(e))
      a.set(r, l);
  return a;
}
async function Se(e, t) {
  if (t)
    if (Array.isArray(t))
      for (const s of t)
        await s(e);
    else
      await t(e);
}
const Vn = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), xn = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function Dt(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: s = globalThis.Headers,
    AbortController: a = globalThis.AbortController
  } = e;
  async function r(n) {
    const u = n.error && n.error.name === "AbortError" && !n.options.timeout || !1;
    if (n.options.retry !== !1 && !u) {
      let o;
      typeof n.options.retry == "number" ? o = n.options.retry : o = wt(n.options.method) ? 0 : 1;
      const y = n.response && n.response.status || 500;
      if (o > 0 && (Array.isArray(n.options.retryStatusCodes) ? n.options.retryStatusCodes.includes(y) : Vn.has(y))) {
        const C = typeof n.options.retryDelay == "function" ? n.options.retryDelay(n) : n.options.retryDelay || 0;
        return C > 0 && await new Promise((p) => setTimeout(p, C)), l(n.request, {
          ...n.options,
          retry: o - 1
        });
      }
    }
    const d = kn(n);
    throw Error.captureStackTrace && Error.captureStackTrace(d, l), d;
  }
  const l = async function(u, d = {}) {
    const o = {
      request: u,
      options: Pn(
        u,
        d,
        e.defaults,
        s
      ),
      response: void 0,
      error: void 0
    };
    o.options.method && (o.options.method = o.options.method.toUpperCase()), o.options.onRequest && await Se(o, o.options.onRequest), typeof o.request == "string" && (o.options.baseURL && (o.request = Nt(o.request, o.options.baseURL)), o.options.query && (o.request = Ft(o.request, o.options.query), delete o.options.query), "query" in o.options && delete o.options.query, "params" in o.options && delete o.options.params), o.options.body && wt(o.options.method) && (Sn(o.options.body) ? (o.options.body = typeof o.options.body == "string" ? o.options.body : JSON.stringify(o.options.body), o.options.headers = new s(o.options.headers || {}), o.options.headers.has("content-type") || o.options.headers.set("content-type", "application/json"), o.options.headers.has("accept") || o.options.headers.set("accept", "application/json")) : (
      // ReadableStream Body
      ("pipeTo" in o.options.body && typeof o.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof o.options.body.pipe == "function") && ("duplex" in o.options || (o.options.duplex = "half"))
    ));
    let y;
    if (!o.options.signal && o.options.timeout) {
      const p = new a();
      y = setTimeout(() => {
        const v = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        v.name = "TimeoutError", v.code = 23, p.abort(v);
      }, o.options.timeout), o.options.signal = p.signal;
    }
    try {
      o.response = await t(
        o.request,
        o.options
      );
    } catch (p) {
      return o.error = p, o.options.onRequestError && await Se(
        o,
        o.options.onRequestError
      ), await r(o);
    } finally {
      y && clearTimeout(y);
    }
    if ((o.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    o.response._bodyInit) && !xn.has(o.response.status) && o.options.method !== "HEAD") {
      const p = (o.options.parseResponse ? "json" : o.options.responseType) || $n(o.response.headers.get("content-type") || "");
      switch (p) {
        case "json": {
          const v = await o.response.text(), x = o.options.parseResponse || At;
          o.response._data = x(v);
          break;
        }
        case "stream": {
          o.response._data = o.response.body || o.response._bodyInit;
          break;
        }
        default:
          o.response._data = await o.response[p]();
      }
    }
    return o.options.onResponse && await Se(
      o,
      o.options.onResponse
    ), !o.options.ignoreResponseError && o.response.status >= 400 && o.response.status < 600 ? (o.options.onResponseError && await Se(
      o,
      o.options.onResponseError
    ), await r(o)) : o.response;
  }, c = async function(u, d) {
    return (await l(u, d))._data;
  };
  return c.raw = l, c.native = (...n) => t(...n), c.create = (n = {}, u = {}) => Dt({
    ...e,
    ...u,
    defaults: {
      ...e.defaults,
      ...u.defaults,
      ...n
    }
  }), c;
}
const Ie = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})(), Mn = Ie.fetch ? (...e) => Ie.fetch(...e) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), In = Ie.Headers, qn = Ie.AbortController, An = Dt({ fetch: Mn, Headers: In, AbortController: qn }), On = ft(), Un = hn(), Q = An.create({
  baseURL: On,
  onRequest({ options: e }) {
    if (e.needToken) {
      const t = He();
      t && (e.headers = {
        ...e.headers,
        authorization: `Bearer ${t}`
      });
    }
    e.headers = {
      ...e.headers,
      ...Un
    };
  },
  onResponse({ response: e }) {
    const t = e._data;
    t && ((t.code === "10001003" || t.code === "10001002") && qt(t), (t.code === "10004003" || t.code === "10004510") && _e.create({
      type: "negative",
      message: t.message,
      position: "center",
      timeout: 3e3
    }), t && Object.prototype.hasOwnProperty.call(t, "result") && (e._data = t.result));
  }
});
Q.get = (e, t, s) => Q(e, { ...s, method: "GET", params: t });
Q.post = (e, t, s) => Q(e, { ...s, method: "POST", body: t });
function Nn(e, t = void 0) {
  if (!e || typeof e != "string")
    return !1;
  const s = mo(e, t);
  return !!s && s.isValid();
}
function Fn(e, t = void 0) {
  const s = po(e, t);
  return {
    displayNumber: s.formatInternational(),
    number: s.number
  };
}
function Gt(e) {
  return Q.get("/api/station/user/getUserInfo/v2", e, { needToken: !0 });
}
function Bn(e) {
  return Q.post("/api/station/user/login/preCheck", e);
}
function Ge(e) {
  return Q.post("/api/station/user/login/init", e);
}
function Zt(e, t = {}) {
  const s = new URLSearchParams(Object.entries(t)).toString();
  return Q.post(`/api/station/user/sendVerifyCode${s ? `?${s}` : ""}`, e);
}
function jn(e) {
  return Q.post("/api/station/user/login", e);
}
function Hn(e) {
  return Q.post("/api/station/user/loginByCode", e);
}
function Dn(e) {
  return Q.post("/api/station/user/checkUserAccount", e);
}
function Gn(e) {
  return Q.post("/api/station/user/verifyCode", e);
}
function Qt(e) {
  return Q.post("/api/station/user/registerByCode", e);
}
async function mt(e, t, s) {
  return await Q.post(`/api/station/user/oauth/login/${e}`, t, s);
}
async function Zn(e, t) {
  return await Q.post("/api/station/user/social/sendMailCode", e, t);
}
async function Qn(e, t) {
  return await Q.post("/api/station/user/social/verifyMailCode", e, t);
}
async function zn(e, t) {
  return await Q.post("/api/station/user/social/verifyPass", e, t);
}
async function Xn(e, t) {
  return await Q.post("/api/station/user/quick/register", e, t);
}
async function Yn(e) {
  return await Q.get("/api/station/user/get/privacyPolicy", {
    protocolType: 1,
    client: 1,
    ...e
  });
}
const Kn = /^[0-9|\-() ]+$/;
function zt(e, t) {
  const s = ue(() => ["US", "CA"].includes(t.value.country)), a = ue(() => e.value.account && s.value && Kn.test(e.value.account));
  async function r() {
    const l = a.value ? Fn(`+${e.value.areaCode.displayValue}${e.value.account}`, t.value.country) : null, c = {
      email: a.value ? "" : e.value.account,
      phone: a.value ? l.number : "",
      type: a.value ? 2 : 1
    }, n = await Bn(c);
    if (!n)
      throw new Error("Pre-check failed");
    return {
      account: a.value ? l.displayNumber : e.value.account,
      realPhone: a.value ? l.number : "",
      loginType: n.nextFlow === 1 ? "login" : "register",
      loginMethod: a.value ? "phone" : "email",
      passwordType: a.value ? "code" : "password"
    };
  }
  return {
    isPhoneNum: a,
    isSupportPhoneNum: s,
    handleCheck: r
  };
}
function tt(e) {
  return io() ? (lo(e), !0) : !1;
}
const ot = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Wn = Object.prototype.toString, Jn = (e) => Wn.call(e) === "[object Object]", es = () => {
};
function ts(...e) {
  if (e.length !== 1)
    return co(...e);
  const t = e[0];
  return typeof t == "function" ? Lt(uo(() => ({ get: t, set: es }))) : T(t);
}
function os(e, t) {
  function s(...a) {
    return new Promise((r, l) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(r).catch(l);
    });
  }
  return s;
}
const Xt = (e) => e();
function ns(e = Xt, t = {}) {
  const {
    initialState: s = "active"
  } = t, a = ts(s === "active");
  function r() {
    a.value = !1;
  }
  function l() {
    a.value = !0;
  }
  const c = (...n) => {
    a.value && e(...n);
  };
  return { isActive: Lt(a), pause: r, resume: l, eventFilter: c };
}
function We(e) {
  return Array.isArray(e) ? e : [e];
}
function ss(e, t, s = {}) {
  const {
    eventFilter: a = Xt,
    ...r
  } = s;
  return Ae(
    e,
    os(
      a,
      t
    ),
    r
  );
}
function as(e, t, s = {}) {
  const {
    eventFilter: a,
    initialState: r = "active",
    ...l
  } = s, { eventFilter: c, pause: n, resume: u, isActive: d } = ns(a, { initialState: r });
  return { stop: ss(
    e,
    t,
    {
      ...l,
      eventFilter: c
    }
  ), pause: n, resume: u, isActive: d };
}
function rs(e, t = 1e3, s = {}) {
  const {
    immediate: a = !0,
    immediateCallback: r = !1
  } = s;
  let l = null;
  const c = Tt(!1);
  function n() {
    l && (clearInterval(l), l = null);
  }
  function u() {
    c.value = !1, n();
  }
  function d() {
    const o = ce(t);
    o <= 0 || (c.value = !0, r && e(), n(), c.value && (l = setInterval(e, o)));
  }
  if (a && ot && d(), qe(t) || typeof t == "function") {
    const o = Ae(t, () => {
      c.value && ot && d();
    });
    tt(o);
  }
  return tt(u), {
    isActive: ro(c),
    pause: u,
    resume: d
  };
}
function is(e, t, s) {
  return Ae(
    e,
    t,
    {
      ...s,
      immediate: !0
    }
  );
}
const Yt = ot ? window : void 0;
function ls(e) {
  var t;
  const s = ce(e);
  return (t = s?.$el) != null ? t : s;
}
function bt(...e) {
  const t = [], s = () => {
    t.forEach((n) => n()), t.length = 0;
  }, a = (n, u, d, o) => (n.addEventListener(u, d, o), () => n.removeEventListener(u, d, o)), r = ue(() => {
    const n = We(ce(e[0])).filter((u) => u != null);
    return n.every((u) => typeof u != "string") ? n : void 0;
  }), l = is(
    () => {
      var n, u;
      return [
        (u = (n = r.value) == null ? void 0 : n.map((d) => ls(d))) != null ? u : [Yt].filter((d) => d != null),
        We(ce(r.value ? e[1] : e[0])),
        We(i(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ce(r.value ? e[3] : e[2])
      ];
    },
    ([n, u, d, o]) => {
      if (s(), !n?.length || !u?.length || !d?.length)
        return;
      const y = Jn(o) ? { ...o } : o;
      t.push(
        ...n.flatMap(
          (C) => u.flatMap(
            (p) => d.map((v) => a(C, p, v, y))
          )
        )
      );
    },
    { flush: "post" }
  ), c = () => {
    l(), s();
  };
  return tt(s), c;
}
function Kt(e, t) {
  var s, a;
  const r = Tt(ce(e)), l = rs(() => {
    var o, y;
    const C = r.value - 1;
    r.value = C < 0 ? 0 : C, (o = void 0) == null || o.call(t), r.value <= 0 && (l.pause(), (y = void 0) == null || y.call(t));
  }, (s = void 0) != null ? s : 1e3, { immediate: (a = void 0) != null ? a : !1 }), c = (o) => {
    var y;
    r.value = (y = ce(o)) != null ? y : ce(e);
  }, n = () => {
    l.pause(), c();
  }, u = () => {
    l.isActive.value || r.value > 0 && l.resume();
  };
  return {
    remaining: r,
    reset: c,
    stop: n,
    start: (o) => {
      c(o), l.resume();
    },
    pause: l.pause,
    resume: u,
    isActive: l.isActive
  };
}
function cs(e = "history", t = {}) {
  const {
    initialValue: s = {},
    removeNullishValues: a = !0,
    removeFalsyValues: r = !1,
    write: l = !0,
    writeMode: c = "replace",
    window: n = Yt,
    stringify: u = (V) => V.toString()
  } = t;
  if (!n)
    return we(s);
  const d = we({});
  function o() {
    if (e === "history")
      return n.location.search || "";
    if (e === "hash") {
      const V = n.location.hash || "", k = V.indexOf("?");
      return k > 0 ? V.slice(k) : "";
    } else
      return (n.location.hash || "").replace(/^#/, "");
  }
  function y(V) {
    const k = u(V);
    if (e === "history")
      return `${k ? `?${k}` : ""}${n.location.hash || ""}`;
    if (e === "hash-params")
      return `${n.location.search || ""}${k ? `#${k}` : ""}`;
    const E = n.location.hash || "#", S = E.indexOf("?");
    return S > 0 ? `${n.location.search || ""}${E.slice(0, S)}${k ? `?${k}` : ""}` : `${n.location.search || ""}${E}${k ? `?${k}` : ""}`;
  }
  function C() {
    return new URLSearchParams(o());
  }
  function p(V) {
    const k = new Set(Object.keys(d));
    for (const E of V.keys()) {
      const S = V.getAll(E);
      d[E] = S.length > 1 ? S : V.get(E) || "", k.delete(E);
    }
    Array.from(k).forEach((E) => delete d[E]);
  }
  const { pause: v, resume: x } = as(
    d,
    () => {
      const V = new URLSearchParams("");
      Object.keys(d).forEach((k) => {
        const E = d[k];
        Array.isArray(E) ? E.forEach((S) => V.append(k, S)) : a && E == null || r && !E ? V.delete(k) : V.set(k, E);
      }), N(V, !1);
    },
    { deep: !0 }
  );
  function N(V, k) {
    v(), k && p(V), c === "replace" ? n.history.replaceState(
      n.history.state,
      n.document.title,
      n.location.pathname + y(V)
    ) : n.history.pushState(
      n.history.state,
      n.document.title,
      n.location.pathname + y(V)
    ), x();
  }
  function R() {
    l && N(C(), !0);
  }
  const O = { passive: !0 };
  bt(n, "popstate", R, O), e !== "history" && bt(n, "hashchange", R, O);
  const j = C();
  return j.keys().next().value ? p(j) : Object.assign(d, s), d;
}
function Wt(e) {
  const t = cs("history"), s = t.utm_medium || t.source, a = s ? `${e.value.activityType}_${s}` : e.value.activityType, r = T("");
  return ke(async () => {
    const { versionNumber: c } = await Yn({ countryCode: e.value.country });
    r.value = c;
  }), ue(() => ({
    platForm: "SHOPIFY",
    registerSource: a || "",
    registerChannel: t.channel || "shopify_web",
    redirect: e.value.redirect || location.href,
    utmCampaign: t.utm_campaign || "",
    agreePrivacyVersion: r.value
  }));
}
const Je = [
  "@gmail.com",
  "@hotmail.com",
  "@yahoo.es",
  "@hotmail.es",
  "@yahoo.com",
  "@telefonica.net",
  "@outlook.com"
];
function vt(e) {
  const t = T(!1), s = T(-1), a = ue(() => e.value.account.includes("@"));
  function r() {
    const o = e.value.account, y = o.lastIndexOf("@");
    return y === -1 ? "" : o.slice(y);
  }
  const l = ue(() => {
    if (!a.value)
      return [];
    const o = r();
    return o ? Je.filter((y) => y.startsWith(o)) : Je;
  });
  function c(o) {
    const y = e.value.account, C = y.lastIndexOf("@"), p = y.slice(0, C);
    e.value.account = p + o;
  }
  function n(o) {
    t.value || (t.value = !0);
    const y = l.value;
    y.length && (s.value = (s.value + o + y.length) % y.length);
  }
  function u() {
    const o = l.value;
    s.value >= 0 && s.value < o.length && c(o[s.value]);
  }
  function d(o) {
    const y = e.value.account, C = y.lastIndexOf("@");
    if (C === -1)
      return o;
    const p = y.slice(C);
    return p ? o.replace(new RegExp(p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), (v) => `<b style="color:#b27a7e">${v}</b>`) : o;
  }
  return Ae(() => e.value.account, () => {
    if (!l.value.length)
      return;
    const o = r();
    if (Je.includes(o)) {
      t.value = !1;
      return;
    }
    t.value = !0;
  }), {
    suggestionMenu: t,
    activeSuggestionIndex: s,
    prependEmail: a,
    computedEmailOptions: l,
    selectEmailOption: c,
    moveSuggestion: n,
    applyActiveSuggestion: u,
    highlightSuggestion: d
  };
}
class he extends Error {
  constructor(t) {
    super(t), this.name = "VerificationCodeError";
  }
}
const _t = T("");
function gt(e) {
  const { t } = fe(), s = T(!1), { remaining: a, start: r } = Kt(0);
  async function l(u) {
    const d = await Ge({
      platForm: "SHOPIFY",
      countryCode: e.value.countryCode,
      countryName: e.value.countryName,
      redirectUrl: u
    });
    _t.value = d.sid || "";
  }
  function c(u) {
    if (!(u.status === 10 || u.status === 0))
      return u && u.status === 11 ? (l(), t("login.code.errorSessionExpired")) : u && u.status === 12 ? t("login.code.errorIncorrect") : t("login.common.unknownError");
  }
  async function n(u, d = {}) {
    if ((await Dn(u)).status !== 1) {
      const C = u.type === 2 ? t("login.account.existsPhone") : t("login.account.existsEmail");
      throw new he(C);
    }
    const y = await Zt(u, d);
    if (Reflect.has(y, "message"))
      throw new he(y.message || t("login.code.errorSendFail"));
    if (!y.codeLength)
      throw new he(c(y));
  }
  return {
    sid: _t,
    verifyCodeSending: s,
    remaining: a,
    start: r,
    sendVerificationCode: n,
    getVerifyCodeError: c,
    getInitSid: l
  };
}
const us = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26415)'%3e%3cpath%20d='M40.24%2035.3791C39.7863%2036.4272%2039.2492%2037.392%2038.627%2038.279C37.7789%2039.4882%2037.0845%2040.3253%2036.5493%2040.7901C35.7197%2041.553%2034.8309%2041.9437%2033.879%2041.966C33.1957%2041.966%2032.3717%2041.7715%2031.4125%2041.3771C30.4501%2040.9845%2029.5657%2040.7901%2028.757%2040.7901C27.9089%2040.7901%2026.9993%2040.9845%2026.0263%2041.3771C25.0519%2041.7715%2024.2669%2041.9771%2023.6668%2041.9974C22.754%2042.0363%2021.8442%2041.6345%2020.9361%2040.7901C20.3565%2040.2845%2019.6315%2039.4179%2018.763%2038.1901C17.8312%2036.8791%2017.0651%2035.3587%2016.465%2033.6255C15.8222%2031.7533%2015.5%2029.9404%2015.5%2028.1853C15.5%2026.1748%2015.9344%2024.4407%2016.8046%2022.9876C17.4885%2021.8204%2018.3982%2020.8997%2019.5369%2020.2238C20.6756%2019.5479%2021.9059%2019.2035%2023.2309%2019.1815C23.9558%2019.1815%2024.9066%2019.4057%2026.088%2019.8464C27.2661%2020.2886%2028.0226%2020.5129%2028.3542%2020.5129C28.6022%2020.5129%2029.4425%2020.2507%2030.8671%2019.7279C32.2143%2019.2431%2033.3513%2019.0424%2034.2827%2019.1215C36.8067%2019.3252%2038.703%2020.3201%2039.964%2022.1127C37.7067%2023.4804%2036.5901%2025.3961%2036.6123%2027.8536C36.6327%2029.7678%2037.3271%2031.3607%2038.6919%2032.6255C39.3103%2033.2125%2040.0011%2033.6662%2040.7696%2033.9884C40.6029%2034.4717%2040.427%2034.9347%2040.24%2035.3791ZM34.4512%2012.6002C34.4512%2014.1005%2033.9031%2015.5014%2032.8106%2016.798C31.4921%2018.3394%2029.8973%2019.2302%2028.1679%2019.0896C28.1459%2018.9096%2028.1331%2018.7202%2028.1331%2018.5211C28.1331%2017.0808%2028.7601%2015.5393%2029.8736%2014.279C30.4295%2013.6409%2031.1365%2013.1103%2031.9939%2012.687C32.8494%2012.2701%2033.6587%2012.0395%2034.4198%2012C34.442%2012.2006%2034.4512%2012.4012%2034.4512%2012.6002V12.6002Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26415'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2012)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", oe = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [a, r] of t)
    s[a] = r;
  return s;
}, ds = {
  __name: "index",
  setup(e) {
    const t = pe(), s = me("config");
    function a() {
      r();
    }
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const c = await Ge({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "apple_login_redirect",
          s.value.redirect || location.href
        );
        const n = c.sid || "", u = await mt("apple_shopify", { sid: n, redirectUri: `${location.origin}/pages/third-login-auth?channel=apple_shopify` });
        window.location.href = u;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      a();
    }
    return (c, n) => ($(), H("div", {
      class: "facebook-login",
      onClick: l
    }, [...n[0] || (n[0] = [
      _("img", {
        src: us,
        alt: ""
      }, null, -1)
    ])]));
  }
}, fs = /* @__PURE__ */ oe(ds, [["__scopeId", "data-v-5191cdb9"]]), ps = { class: "mc-login__title" }, ms = ["innerHTML"], vs = {
  __name: "checkForm",
  props: /* @__PURE__ */ be({
    intelCodeList: { type: Array, default: () => [] }
  }, {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  }),
  emits: /* @__PURE__ */ be(["step"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, a = Oe(e, "form"), { t: r } = fe(), l = me("config"), {
      suggestionMenu: c,
      activeSuggestionIndex: n,
      computedEmailOptions: u,
      selectEmailOption: d,
      moveSuggestion: o,
      applyActiveSuggestion: y,
      highlightSuggestion: C
    } = vt(a), { isPhoneNum: p, isSupportPhoneNum: v, handleCheck: x } = zt(a, l), N = ue(() => p.value ? r("login.form.labelMobile") : !a.value.account && v.value ? r("login.form.labelEmailOrMobile") : r("login.form.labelEmail"));
    function R() {
      if (!a.value.account)
        return r("login.form.validateRequired");
      if (p.value && !Nn(`+1${a.value.account}`))
        return r("login.form.validatePhone");
      if (!p.value && !pt.test(a.value.account))
        return r("login.form.validateEmail");
    }
    const O = T(!1);
    async function j() {
      try {
        O.value = !0;
        const V = await x();
        s("step", V);
      } finally {
        O.value = !1;
      }
    }
    return (V, k) => ($(), F(i(Ce), {
      class: "mc-login__card mc-check",
      onSubmit: Z(j, ["prevent"])
    }, {
      default: w(() => [
        _("div", ps, q(i(r)("login.title")), 1),
        b(i(te), {
          modelValue: a.value.account,
          "onUpdate:modelValue": k[2] || (k[2] = (E) => a.value.account = E),
          autofocus: "",
          outlined: "",
          "no-error-icon": "",
          label: N.value,
          class: "item-input account-input",
          maxlength: "50",
          autocomplete: "username",
          rules: [R],
          onKeydown: [
            k[3] || (k[3] = ie(Z((E) => i(o)(1), ["prevent"]), ["down"])),
            k[4] || (k[4] = ie(Z((E) => i(o)(-1), ["prevent"]), ["up"])),
            ie(Z(i(y), ["prevent"]), ["enter"])
          ]
        }, $t({
          default: w(() => [
            b(i(nt), {
              modelValue: i(c),
              "onUpdate:modelValue": k[1] || (k[1] = (E) => qe(c) ? c.value = E : null),
              anchor: "bottom left",
              self: "top left",
              fit: "",
              "no-parent-event": "",
              "no-focus": "",
              offset: [0, 4],
              class: "email-menu",
              cover: !1
            }, {
              default: w(() => [
                b(i(st), { class: "email-menu__list" }, {
                  default: w(() => [
                    ($(!0), H(Ue, null, lt(i(u), (E, S) => ($(), F(i(at), {
                      key: E,
                      clickable: "",
                      dense: "",
                      active: S === i(n),
                      onMouseenter: (D) => n.value = S,
                      onClick: (D) => i(d)(E)
                    }, {
                      default: w(() => [
                        b(i(rt), null, {
                          default: w(() => [
                            _("span", {
                              innerHTML: i(C)(E)
                            }, null, 8, ms)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 2
        }, [
          i(p) ? {
            name: "prepend",
            fn: w(() => [
              b(i(oo), {
                modelValue: a.value.areaCode,
                "onUpdate:modelValue": k[0] || (k[0] = (E) => a.value.areaCode = E),
                class: "area-code-select",
                outlined: "",
                options: e.intelCodeList
              }, {
                selected: w(() => [
                  _("span", null, "+ " + q(a.value.areaCode.displayValue), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "label", "rules", "onKeydown"]),
        b(i(Y), {
          loading: O.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: w(() => [
            K(q(i(r)("login.form.continue")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }));
  }
}, gs = /* @__PURE__ */ oe(vs, [["__scopeId", "data-v-5ca98520"]]), ys = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26422)'%3e%3cpath%20d='M43%2028C43%2019.7158%2036.2842%2013%2028%2013C19.7158%2013%2013%2019.7158%2013%2028C13%2035.0344%2017.8432%2040.9372%2024.3766%2042.5584V32.584H21.2836V28H24.3766V26.0248C24.3766%2020.9194%2026.6872%2018.553%2031.6996%2018.553C32.65%2018.553%2034.2898%2018.7396%2034.9606%2018.9256V23.0806C34.6066%2023.0434%2033.9916%2023.0248%2033.2278%2023.0248C30.7684%2023.0248%2029.818%2023.9566%2029.818%2026.3788V28H34.7176L33.8758%2032.584H29.818V42.8902C37.2454%2041.9932%2043.0006%2035.6692%2043.0006%2028H43Z'%20fill='%230866FF'/%3e%3cpath%20d='M33.8735%2032.5857L34.7153%2028.0017H29.8157V26.3805C29.8157%2023.9583%2030.7661%2023.0265%2033.2255%2023.0265C33.9893%2023.0265%2034.6043%2023.0451%2034.9583%2023.0823V18.9273C34.2875%2018.7407%2032.6477%2018.5547%2031.6973%2018.5547C26.6849%2018.5547%2024.3743%2020.9211%2024.3743%2026.0265V28.0017H21.2812V32.5857H24.3743V42.5601C25.5347%2042.8481%2026.7485%2043.0017%2027.9977%2043.0017C28.6127%2043.0017%2029.2193%2042.9639%2029.8151%2042.8919V32.5857H33.8729H33.8735Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26422'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", hs = {
  __name: "index",
  setup(e) {
    const t = pe(), s = me("config");
    function a() {
      r();
    }
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const c = await Ge({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "facebook_login_redirect",
          s.value.redirect || location.href
        );
        const n = c.sid || "", u = await mt("facebook_shopify", { sid: n, redirectUri: `${location.origin}/pages/third-login-auth?channel=facebook_shopify` });
        window.location.href = u;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    async function l() {
      a();
    }
    return (c, n) => ($(), H("div", {
      class: "facebook-login",
      onClick: l
    }, [...n[0] || (n[0] = [
      _("img", {
        src: ys,
        alt: ""
      }, null, -1)
    ])]));
  }
}, ws = /* @__PURE__ */ oe(hs, [["__scopeId", "data-v-bb02ab7e"]]), bs = "data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='28'%20fill='%23F5F5F5'/%3e%3cg%20clip-path='url(%23clip0_4575_26410)'%3e%3cpath%20d='M28%2025.2734V31.0825H36.0727C35.7182%2032.9507%2034.6545%2034.5326%2033.059%2035.5962L37.9272%2039.3735C40.7635%2036.7554%2042.3999%2032.9099%2042.3999%2028.3418C42.3999%2027.2782%2042.3045%2026.2553%2042.1272%2025.2736L28%2025.2734Z'%20fill='%234285F4'/%3e%3cpath%20d='M19.5938%2030.8594L18.4958%2031.6998L14.6094%2034.7271C17.0776%2039.6225%2022.1363%2043.0044%2027.9999%2043.0044C32.0498%2043.0044%2035.4452%2041.668%2037.927%2039.3771L33.0589%2035.5998C31.7225%2036.4998%2030.018%2037.0453%2027.9999%2037.0453C24.0999%2037.0453%2020.7863%2034.4135%2019.5999%2030.868L19.5938%2030.8594Z'%20fill='%2334A853'/%3e%3cpath%20d='M14.609%2021.2734C13.5863%2023.2915%2013%2025.5688%2013%2027.9961C13%2030.4233%2013.5863%2032.7006%2014.609%2034.7187C14.609%2034.7323%2019.6%2030.846%2019.6%2030.846C19.3%2029.946%2019.1226%2028.9915%2019.1226%2027.9959C19.1226%2027.0003%2019.3%2026.0458%2019.6%2025.1459L14.609%2021.2734Z'%20fill='%23FBBC05'/%3e%3cpath%20d='M28.0002%2018.9727C30.2093%2018.9727%2032.1729%2019.7363%2033.7411%2021.2091L38.0365%2016.9137C35.4319%2014.4865%2032.0502%2013%2028.0002%2013C22.1366%2013%2017.0776%2016.3682%2014.6094%2021.2773L19.6002%2025.15C20.7865%2021.6045%2024.1002%2018.9727%2028.0002%2018.9727Z'%20fill='%23EA4335'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_4575_26410'%3e%3crect%20width='30'%20height='30'%20fill='white'%20transform='translate(13%2013)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", _s = {
  __name: "index",
  props: {
    defaultRegion: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = pe(), s = me("config");
    let a = "";
    async function r() {
      t.loading.show({
        message: "loading..."
      });
      try {
        const l = await Ge({
          platForm: "SHOPIFY",
          countryCode: s.value.country || "US",
          countryName: s.value.countryName || "United States",
          redirectUrl: s.value.redirect || location.href,
          registerSource: s.value.activityType || "",
          registerChannel: "shopify_web"
        });
        window.localStorage.setItem(
          "google_login_redirect",
          s.value.redirect || location.href
        ), a = l.sid || "";
        const c = await mt("google_shopify", { sid: a, redirectUri: `${location.origin}/pages/third-login-auth?channel=google_shopify` });
        window.location.href = c;
      } catch {
        t.notify({
          type: "negative",
          message: "Login failed. Please try again."
        });
      } finally {
        t.loading.hide();
      }
    }
    return (l, c) => ($(), H("div", {
      class: "goole-login",
      onClick: r
    }, [...c[0] || (c[0] = [
      _("img", {
        src: bs,
        alt: ""
      }, null, -1)
    ])]));
  }
}, Cs = /* @__PURE__ */ oe(_s, [["__scopeId", "data-v-23cb802b"]]);
function Jt(e) {
  const t = T(!1);
  function s() {
    t.value || window.initGeetest4 && window.initGeetest4(
      {
        captchaId: "dfac81b336844c9273d8ab448c45c55f",
        product: "bind",
        hideSuccess: !0,
        language: "eng"
      },
      (r) => {
        t.value = r, r.onReady(() => {
        }).onSuccess(() => {
          const l = r.getValidate();
          console.log("gt4 result", l), e({
            lotNumber: l.lot_number,
            captchaOutput: l.captcha_output,
            passToken: l.pass_token,
            genTime: l.gen_time
          }), r.reset();
        }).onError(() => {
        });
      }
    );
  }
  function a() {
    t.value && t.value.showCaptcha();
  }
  return {
    initGeetest: s,
    sendGetCodeHandle: a
  };
}
const eo = `${ft()}/forget_pwd`, ks = { class: "mc-login__title" }, Es = {
  key: 0,
  class: "text-btn"
}, Ss = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ts = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ls = {
  key: 2,
  class: "mc-login_switch-container"
}, $s = { class: "mc-login_setPassword" }, Ps = ["href"], Rs = {
  __name: "loginForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ be(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, a = Oe(e, "form"), { t: r } = fe(), l = me("config"), { remaining: c, start: n, reset: u } = Kt(0), d = T(!0), { sid: o, getInitSid: y, getVerifyCodeError: C } = gt(a), p = ge("verifyCodeRef"), v = T(""), x = T(!1);
    async function N(I = {}) {
      try {
        x.value = !0, await y(l.value.redirect || location.href);
        const h = await Zt(
          {
            scene: 2,
            sid: o.value,
            phone: a.value.account,
            type: 2
          },
          I
        );
        if (Reflect.has(h, "message")) {
          n(60), p.value.focus(), v.value = h.message || r("login.code.errorSendFail");
          return;
        }
        if (Reflect.has(h, "status")) {
          if (h.status === 11) {
            v.value = r("login.code.errorSessionExpired");
            return;
          } else if (h.status === 12) {
            v.value = r("login.code.errorIncorrect");
            return;
          }
        }
        n(60), p.value.focus();
      } finally {
        x.value = !1;
      }
    }
    function R() {
      s("step", {
        loginType: "",
        loginMethod: "",
        passwordType: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function O() {
      if (!a.value.code) {
        v.value = r("login.code.validateRequired");
        return;
      }
      if (a.value.code.length !== 6) {
        v.value = r("login.code.validateLength");
        return;
      }
      v.value = "";
    }
    function j() {
      if (!a.value.password)
        return r("login.password.validateRequired");
      if (a.value.password.length < 6)
        return r("login.password.validateLength");
    }
    const V = T(!1), k = T("");
    function E() {
      v.value = "", k.value = "", a.value.passwordType === "password" ? (a.value.passwordType = "code", u(), y(l.value.redirect || location.href)) : a.value.passwordType = "password";
    }
    async function S() {
      const I = {
        code: a.value.code,
        sid: o.value,
        phone: a.value.realPhone,
        loginType: 2,
        activityType: l.value.activityType
      }, h = await Hn(I);
      if (v.value = C(h), !v.value)
        return h;
    }
    async function D() {
      const I = {
        platForm: "SHOPIFY",
        phone: a.value.loginMethod === "phone" ? a.value.realPhone : "",
        email: a.value.loginMethod === "email" ? a.value.account : "",
        type: a.value.loginMethod === "phone" ? 2 : 1,
        subscribeNews: a.value.subscribeNews,
        password: De(a.value.password),
        activityType: l.value.activityType,
        redirect: l.value.redirect || location.href
      }, h = await jn(I);
      if (h.code === "10004013" || !h.token) {
        k.value = h.message || r("login.password.errorIncorrect");
        return;
      }
      return k.value = "", h;
    }
    async function z() {
      try {
        V.value = !0;
        let I = null;
        a.value.passwordType === "password" ? I = await D() : I = await S(), s("success", {
          type: "login",
          email: I.email,
          token: I.token,
          shopifyLoginToken: I.shopifyLoginToken
        });
      } finally {
        V.value = !1;
      }
    }
    const { initGeetest: B, sendGetCodeHandle: W } = Jt(N);
    ke(() => {
      B();
    });
    function X() {
      a.value.loginMethod === "phone" ? W() : N();
    }
    return (I, h) => ($(), F(i(Ce), {
      class: "mc-login__card",
      onSubmit: Z(z, ["prevent"])
    }, {
      default: w(() => [
        _("div", ks, q(i(r)("login.title")), 1),
        b(i(te), {
          modelValue: a.value.account,
          "onUpdate:modelValue": h[0] || (h[0] = (A) => a.value.account = A),
          outlined: "",
          readonly: "",
          class: "item-input account-input"
        }, {
          append: w(() => [
            b(i(Y), {
              class: "text-btn",
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: R
            }, {
              default: w(() => [
                K(q(i(r)("login.actions.change")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        a.value.passwordType === "code" ? ($(), F(i(te), {
          key: 0,
          ref_key: "verifyCodeRef",
          ref: p,
          modelValue: a.value.code,
          "onUpdate:modelValue": h[1] || (h[1] = (A) => a.value.code = A),
          rules: [O],
          maxlength: "6",
          "no-error-icon": "",
          type: "text",
          label: i(r)("login.code.label"),
          class: "item-input",
          outlined: "",
          "error-message": v.value,
          error: !!v.value,
          mask: "########"
        }, {
          append: w(() => [
            i(c) > 0 ? ($(), H("span", Es, q(i(c)), 1)) : ($(), F(i(Y), {
              key: 1,
              class: "text-btn",
              loading: x.value,
              flat: "",
              "no-caps": "",
              color: "primary",
              onClick: X
            }, {
              default: w(() => [
                K(q(i(r)("login.code.send")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "label", "error-message", "error"])) : a.value.passwordType === "password" ? ($(), F(i(te), {
          key: 1,
          modelValue: a.value.password,
          "onUpdate:modelValue": [
            h[3] || (h[3] = (A) => a.value.password = A),
            h[4] || (h[4] = (A) => k.value = "")
          ],
          rules: [j],
          outlined: "",
          type: d.value ? "password" : "text",
          label: i(r)("login.password.label"),
          class: "item-input",
          "no-error-icon": "",
          autocomplete: "current-password",
          "error-message": k.value,
          error: !!k.value
        }, {
          append: w(() => [
            _("div", {
              onClick: h[2] || (h[2] = (A) => d.value = !d.value)
            }, [
              d.value ? ($(), H("svg", Ts, [...h[6] || (h[6] = [
                _("path", {
                  d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                  fill: "black"
                }, null, -1),
                _("path", {
                  d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                  fill: "black"
                }, null, -1)
              ])])) : ($(), H("svg", Ss, [...h[5] || (h[5] = [
                _("path", {
                  d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                  fill: "black"
                }, null, -1)
              ])]))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "rules", "type", "label", "error-message", "error"])) : ne("", !0),
        a.value.loginMethod === "phone" ? ($(), H("div", Ls, [
          _("button", {
            type: "button",
            class: "mc-login_switch",
            onClick: E
          }, q(a.value.passwordType === "password" ? i(r)("login.switch.codeLogin") : i(r)("login.switch.passwordLogin")), 1)
        ])) : ne("", !0),
        b(i(Y), {
          loading: V.value,
          type: "submit",
          class: "mc-login__btn"
        }, {
          default: w(() => [
            K(q(i(r)("login.actions.signIn")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _("div", $s, [
          _("a", {
            href: i(eo),
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "forget password (opens in a new tab)",
            "aria-describedby": "a11y-new-window-message"
          }, q(i(r)("login.actions.forgotPassword")), 9, Ps)
        ])
      ]),
      _: 1
    }));
  }
}, Vs = /* @__PURE__ */ oe(Rs, [["__scopeId", "data-v-6b85d1ff"]]), xs = { class: "mc-login__container register-container" }, Ms = { class: "title" }, Is = ["innerHTML"], qs = {
  key: 0,
  class: "text-btn"
}, As = {
  __name: "verifyEmailWhenPhone",
  props: {
    data: {
      type: Object
    },
    registerInfo: {
      type: Object,
      required: !0
    }
  },
  emits: ["success"],
  setup(e, { expose: t, emit: s }) {
    const a = e, r = s, { t: l } = fe(), c = T(!1), n = T({
      account: "",
      code: "",
      areaCode: a.data.areaCode
    }), {
      suggestionMenu: u,
      activeSuggestionIndex: d,
      computedEmailOptions: o,
      selectEmailOption: y,
      moveSuggestion: C,
      applyActiveSuggestion: p,
      highlightSuggestion: v
    } = vt(n);
    function x() {
      if (!n.value.account)
        return l("login.form.validateEmailRequired");
      if (!pt.test(n.value.account))
        return l("login.form.validateEmail");
    }
    const N = ge("verifyCodeRef"), R = T("");
    function O() {
      if (!n.value.code) {
        R.value = l("login.code.validateRequired");
        return;
      }
      if (n.value.code.length !== 6) {
        R.value = l("login.code.validateLength");
        return;
      }
      R.value = "";
    }
    const {
      sid: j,
      verifyCodeSending: V,
      remaining: k,
      start: E,
      sendVerificationCode: S,
      getVerifyCodeError: D
    } = gt(n);
    async function z() {
      try {
        V.value = !0;
        const I = {
          scene: 1,
          sid: j.value,
          email: n.value.account,
          type: 1
        };
        await S(I), n.value.code = "", R.value = "", Pt(() => N.value.resetValidation()), E(60), N.value.focus();
      } catch (I) {
        I instanceof he ? R.value = I.message : R.value = l("login.common.unknownError");
      } finally {
        V.value = !1;
      }
    }
    const B = T(!1);
    async function W() {
      try {
        B.value = !0;
        const I = {
          registerType: 2,
          subscribeNews: a.data.subscribeNews,
          firstName: "",
          lastName: "",
          phone: a.data.account,
          email: n.value.account,
          password: De(a.data.password),
          babyBirthday: a.data.babyBirthday,
          sid: j.value,
          code: n.value.code,
          ...a.registerInfo
        }, h = await Qt(I);
        if (R.value = D(h), B.value = !1, R.value)
          return;
        r("success", {
          type: "register",
          email: h.email,
          token: h.token,
          shopifyLoginToken: h.shopifyLoginToken
        });
      } catch {
        R.value = l("login.common.unknownError");
      }
    }
    function X() {
      c.value = !1;
    }
    return t({
      open() {
        c.value = !0;
      }
    }), (I, h) => ($(), F(i(Re), {
      modelValue: c.value,
      "onUpdate:modelValue": h[5] || (h[5] = (A) => c.value = A),
      class: "mc-login nt",
      persistent: ""
    }, {
      default: w(() => [
        _("div", xs, [
          b(i(Y), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: X
          }),
          _("div", Ms, q(i(l)("login.phoneRegisterTitle")), 1),
          b(i(Ce), { onSubmit: W }, {
            default: w(() => [
              b(i(te), {
                modelValue: n.value.account,
                "onUpdate:modelValue": h[1] || (h[1] = (A) => n.value.account = A),
                rules: [x],
                label: i(l)("login.form.labelEmail"),
                outlined: "",
                autofocus: "",
                "no-error-icon": "",
                class: "item-input account-input",
                maxlength: "50",
                autocomplete: "username",
                onKeydown: [
                  h[2] || (h[2] = ie(Z((A) => i(C)(1), ["prevent"]), ["down"])),
                  h[3] || (h[3] = ie(Z((A) => i(C)(-1), ["prevent"]), ["up"])),
                  ie(Z(i(p), ["prevent"]), ["enter"])
                ]
              }, {
                default: w(() => [
                  b(i(nt), {
                    modelValue: i(u),
                    "onUpdate:modelValue": h[0] || (h[0] = (A) => qe(u) ? u.value = A : null),
                    anchor: "bottom left",
                    self: "top left",
                    fit: "",
                    "no-parent-event": "",
                    "no-focus": "",
                    offset: [0, 4],
                    class: "email-menu",
                    cover: !1
                  }, {
                    default: w(() => [
                      b(i(st), { class: "email-menu__list" }, {
                        default: w(() => [
                          ($(!0), H(Ue, null, lt(i(o), (A, U) => ($(), F(i(at), {
                            key: A,
                            clickable: "",
                            dense: "",
                            active: U === i(d),
                            onMouseenter: (J) => d.value = U,
                            onClick: (J) => i(y)(A)
                          }, {
                            default: w(() => [
                              b(i(rt), null, {
                                default: w(() => [
                                  _("span", {
                                    innerHTML: i(v)(A)
                                  }, null, 8, Is)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "onKeydown"]),
              b(i(te), {
                ref_key: "verifyCodeRef",
                ref: N,
                modelValue: n.value.code,
                "onUpdate:modelValue": h[4] || (h[4] = (A) => n.value.code = A),
                rules: [O],
                maxlength: "6",
                "no-error-icon": "",
                type: "text",
                label: i(l)("login.code.label"),
                class: "item-input",
                outlined: "",
                "error-message": R.value,
                error: !!R.value,
                autocomplete: "one-time-code",
                mask: "########"
              }, {
                append: w(() => [
                  i(k) > 0 ? ($(), H("span", qs, q(i(k)), 1)) : ($(), F(i(Y), {
                    key: 1,
                    class: "text-btn",
                    loading: i(V),
                    flat: "",
                    "no-caps": "",
                    color: "primary",
                    onClick: z
                  }, {
                    default: w(() => [
                      K(q(i(l)("login.code.send")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                ]),
                _: 1
              }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
              b(i(Y), {
                type: "submit",
                loading: B.value,
                class: "mc-login__btn"
              }, {
                default: w(() => [
                  K(q(i(l)("login.common.confirm")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}, Os = /* @__PURE__ */ oe(As, [["__scopeId", "data-v-43a81e89"]]), Us = { class: "mc-register-login__title" }, Ns = {
  key: 0,
  class: "text-btn"
}, Fs = {
  key: 0,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bs = {
  key: 1,
  class: "pwd-icon",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, js = { class: "row items-center justify-end" }, Hs = { class: "mc-register__terms" }, Ds = ["href"], Gs = {
  __name: "registerForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ be(["step", "success"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, a = pe(), r = Et, l = me("config", {}), { t: c } = fe(), n = Oe(e, "form"), u = Wt(l), d = ge("verifyCodeRef"), o = T(""), {
      sid: y,
      verifyCodeSending: C,
      remaining: p,
      start: v,
      sendVerificationCode: x,
      getVerifyCodeError: N,
      getInitSid: R
    } = gt(n);
    async function O(m = {}) {
      try {
        C.value = !0, await R(u.value.redirect);
        const g = {
          scene: 1,
          sid: y.value,
          phone: n.value.loginMethod === "phone" ? n.value.realPhone : "",
          email: n.value.loginMethod === "email" ? n.value.account : "",
          type: n.value.loginMethod === "phone" ? 2 : 1
        };
        await x(g, m), n.value.code = "", o.value = "", Pt(() => {
          d.value.resetValidation();
        }), v(60), d.value.focus();
      } catch (g) {
        v(60), d.value.focus(), g instanceof he ? o.value = g.message : o.value = c("login.common.unknownError");
      } finally {
        C.value = !1;
      }
    }
    function j() {
      s("step", {
        loginType: "",
        loginMethod: "",
        code: "",
        password: "",
        realPhone: ""
      });
    }
    function V() {
      if (!n.value.code) {
        o.value = c("login.code.validateRequired");
        return;
      }
      if (n.value.code.length !== 6) {
        o.value = c("login.code.validateLength");
        return;
      }
      o.value = "";
    }
    const k = T(!0);
    function E() {
      if (!n.value.password)
        return c("login.password.validateRequired");
      if (n.value.password.length < 6)
        return c("login.password.validateLength");
    }
    const S = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function D() {
      if (!n.value.babyBirthday)
        return c("login.birthday.validateRequired_html");
      if (!S.test(n.value.babyBirthday))
        return c("login.birthday.validateInvalid_html");
    }
    const z = ge("verifyEmailWhenPhoneRef"), B = T(!1);
    async function W() {
      const m = {
        phone: n.value.account,
        code: n.value.code,
        sid: y.value,
        scene: 1,
        type: 2
      }, g = await Gn(m);
      o.value = N(g), !o.value && z.value.open();
    }
    async function X() {
      try {
        const m = {
          registerType: 1,
          subscribeNews: n.value.subscribeNews,
          firstName: "",
          lastName: "",
          email: n.value.account,
          password: De(n.value.password),
          babyBirthday: n.value.babyBirthday,
          sid: y.value,
          code: n.value.code,
          ...u.value
        }, g = await Qt(m);
        if (o.value = N(g), o.value)
          return;
        s("success", {
          type: "register",
          email: g.email,
          token: g.token,
          shopifyLoginToken: g.shopifyLoginToken
        });
      } catch {
        o.value = c("login.common.unknownError");
      }
    }
    const I = ge("policyRef");
    function h(m) {
      m.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    const A = T(!1);
    function U() {
      A.value = !0, h(I.value);
    }
    function J(m) {
      s("success", m);
    }
    function se() {
      return n.value.agreePolicy ? !0 : (a.notify({
        message: c("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function Qe() {
      try {
        if (!se()) {
          U();
          return;
        }
        B.value = !0, n.value.loginMethod === "phone" ? await W() : await X();
      } finally {
        B.value = !1;
      }
    }
    const { initGeetest: ze, sendGetCodeHandle: f } = Jt(O);
    ke(() => {
      ze();
    });
    function L() {
      n.value.loginMethod === "phone" ? f() : O();
    }
    return (m, g) => {
      const P = G("i18n-t");
      return $(), F(i(Ce), {
        class: "mc-login__card",
        onSubmit: Z(Qe, ["prevent"])
      }, {
        default: w(() => [
          _("div", Us, q(i(c)("login.title")), 1),
          b(i(te), {
            modelValue: n.value.account,
            "onUpdate:modelValue": g[0] || (g[0] = (M) => n.value.account = M),
            outlined: "",
            readonly: "",
            class: "item-input account-input"
          }, {
            append: w(() => [
              b(i(Y), {
                class: "text-btn",
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: j
              }, {
                default: w(() => [
                  K(q(i(c)("login.actions.change")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          b(i(te), {
            ref_key: "verifyCodeRef",
            ref: d,
            modelValue: n.value.code,
            "onUpdate:modelValue": g[1] || (g[1] = (M) => n.value.code = M),
            rules: [V],
            maxlength: "6",
            "no-error-icon": "",
            type: "text",
            label: i(c)("login.code.label"),
            class: "item-input",
            outlined: "",
            "error-message": o.value,
            error: !!o.value,
            autocomplete: "one-time-code",
            mask: "########"
          }, {
            append: w(() => [
              i(p) > 0 ? ($(), H("span", Ns, q(i(p)), 1)) : ($(), F(i(Y), {
                key: 1,
                class: "text-btn",
                loading: i(C),
                flat: "",
                "no-caps": "",
                color: "primary",
                onClick: L
              }, {
                default: w(() => [
                  K(q(i(c)("login.code.send")), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "error-message", "error"]),
          b(i(te), {
            modelValue: n.value.password,
            "onUpdate:modelValue": g[3] || (g[3] = (M) => n.value.password = M),
            rules: [E],
            outlined: "",
            type: k.value ? "password" : "text",
            label: i(c)("login.password.label"),
            class: "item-input",
            "no-error-icon": "",
            autocomplete: "current-password"
          }, {
            append: w(() => [
              _("div", {
                onClick: g[2] || (g[2] = (M) => k.value = !k.value)
              }, [
                k.value ? ($(), H("svg", Bs, [...g[12] || (g[12] = [
                  _("path", {
                    d: "M20.6523 21.2624C20.3367 21.2624 20.0289 21.1015 19.8548 20.8115L17.9992 17.7155C17.7354 17.2752 17.8786 16.7052 18.3186 16.4409C18.7586 16.1771 19.3289 16.3205 19.5926 16.7602L21.4482 19.8562C21.712 20.2965 21.5689 20.8665 21.1289 21.1309C20.9849 21.2171 20.8201 21.2626 20.6523 21.2624ZM25.6001 18.1665C25.3623 18.1665 25.1245 18.0759 24.9432 17.8943L22.4689 15.4174C22.1064 15.054 22.1067 14.4662 22.4695 14.1034C22.8323 13.7418 23.4201 13.7412 23.7829 14.104L26.2573 16.5809C26.6198 16.9443 26.6195 17.5321 26.2567 17.8949C26.1705 17.9811 26.0681 18.0495 25.9555 18.0961C25.8428 18.1427 25.722 18.1666 25.6001 18.1665ZM11.3526 21.2624C11.1901 21.2624 11.0254 21.2202 10.8761 21.1299C10.4357 20.8662 10.2932 20.2962 10.5567 19.8559L12.4123 16.7599C12.6761 16.3202 13.2464 16.1765 13.6864 16.4412C14.1267 16.7049 14.2692 17.2749 14.0057 17.7152L12.1501 20.8112C11.9761 21.1015 11.6682 21.2624 11.3526 21.2624ZM6.40512 18.1665C6.16762 18.1665 5.93012 18.0759 5.74887 17.8949C5.38605 17.5321 5.38574 16.9443 5.74824 16.5809L8.22262 14.104C8.58543 13.7412 9.17324 13.7418 9.53606 14.1034C9.89887 14.4662 9.89918 15.054 9.53668 15.4174L7.0623 17.8943C6.88074 18.0759 6.64293 18.1665 6.40512 18.1665Z",
                    fill: "black"
                  }, null, -1),
                  _("path", {
                    d: "M16.301 17.5478C13.7129 17.5478 9.90541 16.6612 6.46072 12.4375C6.42103 12.3884 6.39041 12.3503 6.36791 12.3244C6.02728 11.9862 5.99822 11.4378 6.31353 11.0653C6.64478 10.6734 7.23072 10.625 7.62228 10.9559C7.66166 10.989 7.7601 11.0912 7.90041 11.2631C10.8838 14.9222 14.1154 15.69 16.301 15.69C20.0726 15.69 24.3657 11.7959 24.7892 11.1772C25.0729 10.764 25.6438 10.6306 26.0673 10.9009C26.4898 11.1706 26.6342 11.7075 26.3788 12.1387C25.9395 12.88 21.1051 17.5478 16.301 17.5478Z",
                    fill: "black"
                  }, null, -1)
                ])])) : ($(), H("svg", Fs, [...g[11] || (g[11] = [
                  _("path", {
                    d: "M15.9975 26C11.1085 26 6.74683 22.9147 2.92217 16.8873C2.75359 16.6221 2.66406 16.3143 2.66406 16C2.66406 15.6857 2.75359 15.3779 2.92217 15.1127C6.74683 9.08533 11.1085 6 15.9975 6C20.8865 6 25.2482 9.08533 29.0728 15.1127C29.2414 15.3779 29.3309 15.6857 29.3309 16C29.3309 16.3143 29.2414 16.6221 29.0728 16.8873C25.2482 22.9147 20.8865 26 15.9975 26ZM15.9975 8C11.9502 8 8.20183 10.6203 4.74383 16C8.20183 21.3797 11.9502 24 15.9975 24C20.0448 24 23.7932 21.3797 27.2512 16C23.7932 10.6203 20.0448 8 15.9975 8ZM15.9975 20.6667C13.3972 20.6667 11.2892 18.5773 11.2892 16C11.2892 13.4227 13.3972 11.3333 15.9975 11.3333C18.5978 11.3333 20.7058 13.4227 20.7058 16C20.7058 18.5773 18.5978 20.6667 15.9975 20.6667ZM15.9975 18.6667C17.4835 18.6667 18.6882 17.4727 18.6882 16C18.6882 14.5273 17.4835 13.3333 15.9975 13.3333C14.5115 13.3333 13.3068 14.5273 13.3068 16C13.3068 17.4727 14.5115 18.6667 15.9975 18.6667Z",
                    fill: "black"
                  }, null, -1)
                ])]))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "type", "label"]),
          b(i(te), {
            modelValue: n.value.babyBirthday,
            "onUpdate:modelValue": g[5] || (g[5] = (M) => n.value.babyBirthday = M),
            class: "item-input",
            outlined: "",
            rules: [D],
            label: i(c)("login.birthday.label_html"),
            placeholder: i(c)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: w(() => [
              b(i(St), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: w(() => [
              b(i(Ct), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: w(() => [
                  b(i(kt), {
                    modelValue: n.value.babyBirthday,
                    "onUpdate:modelValue": g[4] || (g[4] = (M) => n.value.babyBirthday = M),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: w(() => [
                      _("div", js, [
                        Ne(b(i(Y), {
                          label: i(c)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [i(r)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          b(i(Y), {
            type: "submit",
            loading: B.value,
            class: "mc-login__btn"
          }, {
            default: w(() => [
              K(q(i(c)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _("div", Hs, [
            _("div", {
              ref_key: "policyRef",
              ref: I
            }, [
              b(i(ye), {
                modelValue: n.value.agreePolicy,
                "onUpdate:modelValue": g[8] || (g[8] = (M) => n.value.agreePolicy = M),
                size: "sm",
                class: Fe(["item-subscribe", A.value && !n.value.agreePolicy && "error-msg"]),
                "true-value": 1,
                "false-value": 0
              }, {
                default: w(() => [
                  b(P, {
                    keypath: "login.terms.policyInfo",
                    class: "policy-info",
                    tag: "span"
                  }, {
                    privacy: w(() => [
                      _("a", {
                        href: `${i(Ht)}?countryCode=${i(l).country}&client=1&isShowCountry=hide`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Privacy Policy (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-external-message",
                        onClick: g[6] || (g[6] = Z(() => {
                        }, ["stop"]))
                      }, q(m.$t("login.terms.privacy")), 9, Ds)
                    ]),
                    terms: w(() => [
                      _("a", {
                        href: "/pages/terms-conditions",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Terms & Conditions (opens in a new tab)",
                        "aria-describedby": "a11y-new-window-message",
                        onClick: g[7] || (g[7] = Z(() => {
                        }, ["stop"]))
                      }, q(m.$t("login.terms.terms_html")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "class"])
            ], 512)
          ]),
          n.value.loginMethod === "phone" ? ($(), F(i(ye), {
            key: 0,
            modelValue: n.value.subscribeNews,
            "onUpdate:modelValue": g[9] || (g[9] = (M) => n.value.subscribeNews = M),
            size: "sm",
            class: "item-subscribe",
            label: i(c)("login.newsletter.labelPhone"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])) : ($(), F(i(ye), {
            key: 1,
            modelValue: n.value.subscribeNews,
            "onUpdate:modelValue": g[10] || (g[10] = (M) => n.value.subscribeNews = M),
            size: "sm",
            class: "item-subscribe",
            label: i(c)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"])),
          b(Os, {
            ref_key: "verifyEmailWhenPhoneRef",
            ref: z,
            data: n.value,
            "register-info": i(u),
            onSuccess: J
          }, null, 8, ["data", "register-info"])
        ]),
        _: 1
      });
    };
  }
}, Zs = /* @__PURE__ */ oe(Gs, [["__scopeId", "data-v-a3d44dcb"]]), Qs = { class: "mc-login__container" }, zs = { class: "divide-line" }, Xs = { class: "third-content" }, Ys = {
  __name: "login",
  props: {
    country: { type: String, default: "US" },
    countryName: { type: String, default: "United States" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const s = e, a = T({
      ...s
    });
    Rt("config", a);
    const { t: r } = fe(), l = T(!1), c = [
      {
        label: r("login.country.us"),
        value: "US",
        name: "United States",
        displayValue: "1"
      },
      {
        label: r("login.country.ca"),
        value: "CA",
        name: "Canada",
        displayValue: "1"
      }
    ], n = T({
      account: "",
      password: "",
      code: "",
      babyBirthday: "",
      subscribeNews: 0,
      agreePolicy: 0,
      areaCode: c[0],
      loginType: "",
      // login, register
      loginMethod: "",
      // email, phone
      passwordType: "password",
      // password, code
      countryCode: a.value.country,
      countryName: a.value.countryName
    });
    function u(p) {
      const v = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/;
      n.value.account && !v.test(n.value.account) && (n.value.account = ""), n.value = {
        ...n.value,
        ...p
      };
    }
    function d(p) {
      ut(p.token), location.href = p.shopifyLoginToken, C(!0);
    }
    const { handleCheck: o } = zt(n, a);
    async function y(p = {}, v = {}) {
      if (n.value = { ...n.value, ...p }, a.value = { ...s, ...v }, n.value.account && v.checkImmediately) {
        const x = await o();
        u(x);
      }
      l.value = !0;
    }
    function C(p = !1) {
      if (a.value.persistent && !p) {
        document.dispatchEvent(new _n());
        return;
      }
      l.value = !1;
    }
    return ke(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        It();
      });
      const p = He();
      if (p) {
        const v = await Gt();
        v && v.email && (window.__MOMCOZY_USER_INFO__ = {
          email: v.email,
          token: p
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new bn({
            type: "keep",
            email: v.email,
            token: p
          })
        ));
      }
    }), t({
      close: C,
      open: y
    }), (p, v) => ($(), F(i(Re), Vt({
      modelValue: l.value,
      "onUpdate:modelValue": v[4] || (v[4] = (x) => l.value = x),
      class: "mc-login nt"
    }, a.value, {
      onShake: v[5] || (v[5] = (x) => C(!1))
    }), {
      default: w(() => [
        _("div", Qs, [
          b(xt, {
            name: "form",
            tag: "div",
            class: "mc-login__forms"
          }, {
            default: w(() => [
              n.value.loginType ? n.value.loginType === "login" ? ($(), F(Vs, {
                key: "login",
                form: n.value,
                "onUpdate:form": v[1] || (v[1] = (x) => n.value = x),
                class: "login-form",
                onStep: u,
                onSuccess: d
              }, null, 8, ["form"])) : n.value.loginType === "register" ? ($(), F(Zs, {
                key: "register",
                form: n.value,
                "onUpdate:form": v[2] || (v[2] = (x) => n.value = x),
                class: "register-form",
                onStep: u,
                onSuccess: d
              }, null, 8, ["form"])) : ne("", !0) : ($(), F(gs, {
                key: "check",
                form: n.value,
                "onUpdate:form": v[0] || (v[0] = (x) => n.value = x),
                class: "check-form",
                "intel-code-list": c,
                onStep: u
              }, null, 8, ["form"]))
            ]),
            _: 1
          }),
          _("p", zs, [
            _("span", null, q(i(r)("login.or")), 1)
          ]),
          _("div", Xs, [
            b(Cs),
            b(ws),
            b(fs)
          ]),
          b(i(Y), {
            class: "mc-close-icon",
            icon: "close",
            flat: "",
            round: "",
            dense: "",
            onClick: v[3] || (v[3] = (x) => C(!1))
          })
        ])
      ]),
      _: 1
    }, 16, ["modelValue"]));
  }
}, Ks = /* @__PURE__ */ oe(Ys, [["__scopeId", "data-v-5733aa5d"]]), Ws = "data:image/svg+xml,%3csvg%20width='26'%20height='26'%20viewBox='0%200%2026%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='13'%20cy='13'%20r='11.2'%20stroke='%236FC177'%20stroke-width='1.6'/%3e%3cg%20clip-path='url(%23clip0_1602_999)'%3e%3cpath%20d='M8.19077%2012.5013L10.9966%2014.7369L17.9831%208.30061C17.9831%208.30061%2018.4518%207.8727%2018.8613%208.20704C18.9829%208.30701%2019.1236%208.59175%2018.8069%209.03807L11.5125%2017.5826C11.5125%2017.5826%2010.9534%2018.3481%2010.2895%2017.5746L7.14141%2013.3243C7.14141%2013.3243%206.76788%2012.7485%207.23498%2012.4037C7.39334%2012.2886%207.75167%2012.1078%208.19077%2012.5013Z'%20fill='%236FC177'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1602_999'%3e%3crect%20width='12'%20height='12'%20fill='white'%20transform='translate(7%207)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Js = ["innerHTML"], ea = { class: "row items-center justify-end" }, ta = ["href"], oa = {
  __name: "quickRegisterForm",
  props: {
    form: {
      type: Object,
      required: !0
    },
    formModifiers: {}
  },
  emits: /* @__PURE__ */ be(["step", "success", "close"], ["update:form"]),
  setup(e, { emit: t }) {
    const s = t, a = pe(), r = Et, l = me("config", {}), { t: c } = fe(), n = Oe(e, "form");
    n.value && (n.value.protocol = 0);
    const {
      suggestionMenu: u,
      activeSuggestionIndex: d,
      computedEmailOptions: o,
      selectEmailOption: y,
      moveSuggestion: C,
      applyActiveSuggestion: p,
      highlightSuggestion: v
    } = vt(n), x = ue(() => c("login.form.labelEmail"));
    function N() {
      if (!n.value.account || !pt.test(n.value.account))
        return c("login.form.validateEmailRequired");
    }
    const R = Wt(l);
    function O() {
      s("close");
    }
    const j = /^(?:\d{3}[1-9]|\d{2}[1-9]\d|\d[1-9]\d{2}|[1-9]\d{3})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|02-(?:0[1-9]|1\d|2[0-8]))|(?:\d{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[3579][26])00)-02-29$/;
    function V() {
      if (!n.value.babyBirthday)
        return c("login.birthday.validateRequired_html");
      if (!j.test(n.value.babyBirthday))
        return c("login.birthday.validateInvalid_html");
    }
    const k = T(!1);
    async function E() {
      try {
        const I = {
          subscribeNews: n.value.subscribeNews,
          // 订阅
          email: n.value.account,
          // 邮箱
          currentStageValue: n.value.babyBirthday,
          // 预产期
          agreePrivacyCountryCode: l.value.country,
          ...R.value,
          source: R.value.registerSource || ""
        };
        delete I.registerSource;
        const h = await Xn(I);
        h.isRegister === 1 ? s("success", {
          type: "register",
          status: "success",
          message: h.message
        }) : h.code === "10004007" ? s("success", {
          type: "register",
          status: "notActivated",
          message: h.message
        }) : h.code === "10004050" ? s("success", {
          type: "register",
          status: "activated",
          message: h.message
        }) : a.notify({
          message: h.message,
          color: "negative",
          position: "top",
          timeout: 3e3
        });
      } catch {
        console.log("服务错误！");
      }
    }
    const S = ge("termsRef"), D = T(!1);
    function z() {
      D.value = !0, B(S.value);
    }
    function B(I) {
      I.animate(
        {
          transform: [
            "translateX(0)",
            "translateX(-32px)",
            "translateX(32px)",
            "translateX(-16px)",
            "translateX(16px)",
            "translateX(-8px)",
            "translateX(8px)",
            "translateX(-4px)",
            "translateX(4px)",
            "translateX(-2px)",
            "translateX(2px)",
            "translateX(0)"
          ]
        },
        {
          duration: 1e3,
          easing: "cubic-bezier(.36, .07, .19, .97)",
          fill: "forwards"
        }
      );
    }
    function W() {
      return n.value.protocol ? !0 : (a.notify({
        message: c("login.terms.policyTip_html"),
        position: "center",
        classes: "mc-notify--policy",
        multiLine: !0,
        html: !0,
        timeout: 2e3
      }), !1);
    }
    async function X() {
      try {
        if (!W()) {
          z();
          return;
        }
        k.value = !0, await E();
      } finally {
        k.value = !1;
      }
    }
    return (I, h) => {
      const A = G("i18n-t");
      return $(), F(i(Ce), {
        class: "mc-login__card",
        onSubmit: Z(X, ["prevent"])
      }, {
        default: w(() => [
          h[10] || (h[10] = _("div", { class: "mc-register-login__title" }, "Email Registration", -1)),
          b(i(te), {
            modelValue: n.value.account,
            "onUpdate:modelValue": h[1] || (h[1] = (U) => n.value.account = U),
            autofocus: "",
            outlined: "",
            "no-error-icon": "",
            label: x.value,
            class: "item-input account-input",
            maxlength: "50",
            autocomplete: "username",
            rules: [N],
            onKeydown: [
              h[2] || (h[2] = ie(Z((U) => i(C)(1), ["prevent"]), ["down"])),
              h[3] || (h[3] = ie(Z((U) => i(C)(-1), ["prevent"]), ["up"])),
              ie(Z(i(p), ["prevent"]), ["enter"])
            ]
          }, {
            default: w(() => [
              b(i(nt), {
                modelValue: i(u),
                "onUpdate:modelValue": h[0] || (h[0] = (U) => qe(u) ? u.value = U : null),
                anchor: "bottom left",
                self: "top left",
                fit: "",
                "no-parent-event": "",
                "no-focus": "",
                offset: [0, 4],
                class: "email-menu",
                cover: !1
              }, {
                default: w(() => [
                  b(i(st), { class: "email-menu__list" }, {
                    default: w(() => [
                      ($(!0), H(Ue, null, lt(i(o), (U, J) => ($(), F(i(at), {
                        key: U,
                        clickable: "",
                        dense: "",
                        active: J === i(d),
                        onMouseenter: (se) => d.value = J,
                        onClick: (se) => i(y)(U)
                      }, {
                        default: w(() => [
                          b(i(rt), null, {
                            default: w(() => [
                              _("span", {
                                innerHTML: i(v)(U)
                              }, null, 8, Js)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["active", "onMouseenter", "onClick"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "rules", "onKeydown"]),
          b(i(te), {
            modelValue: n.value.babyBirthday,
            "onUpdate:modelValue": h[5] || (h[5] = (U) => n.value.babyBirthday = U),
            class: "item-input",
            outlined: "",
            rules: [V],
            label: i(c)("login.birthday.label_html"),
            placeholder: i(c)("login.birthday.placeholder_html"),
            "no-error-icon": "",
            mask: "####-##-##"
          }, {
            append: w(() => [
              b(i(St), {
                name: "event",
                class: "cursor-pointer"
              })
            ]),
            default: w(() => [
              b(i(Ct), {
                class: "nt",
                "transition-show": "scale",
                "transition-hide": "scale"
              }, {
                default: w(() => [
                  b(i(kt), {
                    modelValue: n.value.babyBirthday,
                    "onUpdate:modelValue": h[4] || (h[4] = (U) => n.value.babyBirthday = U),
                    mask: "YYYY-MM-DD"
                  }, {
                    default: w(() => [
                      _("div", ea, [
                        Ne(b(i(Y), {
                          label: i(c)("login.common.close"),
                          color: "primary",
                          flat: ""
                        }, null, 8, ["label"]), [
                          [i(r)]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules", "label", "placeholder"]),
          b(i(Y), {
            type: "submit",
            loading: k.value,
            class: "mc-login__btn"
          }, {
            default: w(() => [
              K(q(i(c)("login.actions.createAccount")), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _("div", {
            ref_key: "termsRef",
            ref: S,
            class: "mc-register__terms"
          }, [
            b(i(ye), {
              modelValue: n.value.protocol,
              "onUpdate:modelValue": h[8] || (h[8] = (U) => n.value.protocol = U),
              size: "sm",
              class: Fe(["item-subscribe", D.value && !n.value.protocol && "error-msg"]),
              "true-value": 1,
              "false-value": 0
            }, {
              default: w(() => [
                b(A, {
                  keypath: "login.terms.policyInfo",
                  class: "policy-info",
                  tag: "span"
                }, {
                  privacy: w(() => [
                    _("a", {
                      href: `${i(Ht)}?countryCode=${i(l).country}&client=1&isShowCountry=hide`,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Privacy Policy (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-external-message",
                      onClick: h[6] || (h[6] = Z(() => {
                      }, ["stop"]))
                    }, q(I.$t("login.terms.privacy")), 9, ta)
                  ]),
                  terms: w(() => [
                    _("a", {
                      href: "/pages/terms-conditions",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": "Terms & Conditions (opens in a new tab)",
                      "aria-describedby": "a11y-new-window-message",
                      onClick: h[7] || (h[7] = Z(() => {
                      }, ["stop"]))
                    }, q(I.$t("login.terms.terms_html")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "class"])
          ], 512),
          b(i(ye), {
            modelValue: n.value.subscribeNews,
            "onUpdate:modelValue": h[9] || (h[9] = (U) => n.value.subscribeNews = U),
            size: "sm",
            class: "item-subscribe",
            label: i(c)("login.newsletter.labelEmail"),
            "true-value": 1,
            "false-value": 0
          }, null, 8, ["modelValue", "label"]),
          _("div", {
            class: "already-registered",
            onClick: O
          }, " I have registered ")
        ]),
        _: 1
      });
    };
  }
}, na = /* @__PURE__ */ oe(oa, [["__scopeId", "data-v-9649d0c6"]]), sa = { class: "mc-login__container" }, aa = { class: "success-icon-wrapper" }, ra = { class: "success-subtitle" }, ia = { class: "success-message" }, la = {
  __name: "quickRegisterMember",
  props: {
    country: { type: String, default: "US" },
    activityType: { type: String },
    mustAgreeEmail: { type: Boolean, default: !1 },
    loginSubscribeNews: { type: Boolean, default: !1 },
    redirect: { type: String }
  },
  setup(e, { expose: t }) {
    const s = e, a = T({
      ...s
    });
    Rt("config", a);
    const r = T(!1), l = T(!1), c = we({}), n = T({
      account: "",
      babyBirthday: "",
      subscribeNews: 0
      // 协议
    });
    function u(C) {
      Object.assign(c, C), r.value = !1, l.value = !0, document.dispatchEvent(new Eo());
    }
    function d() {
      l.value = !1, y(!0);
    }
    async function o(C = {}, p = {}) {
      n.value = { ...n.value, ...C }, a.value = { ...s, ...p }, r.value = !0;
    }
    function y(C = !1) {
      if (a.value.persistent && !C) {
        document.dispatchEvent(new ko());
        return;
      }
      r.value = !1;
    }
    return ke(async () => {
      document.addEventListener("LUTE:AUTH:EXPIRED", () => {
        It();
      });
      const C = He();
      if (C) {
        const p = await Gt();
        p && p.email && (window.__MOMCOZY_USER_INFO__ = {
          email: p.email,
          token: C
        }, document.body.classList.add("momcozy-logined"), document.dispatchEvent(
          new Co({
            type: "keep",
            email: p.email,
            token: C
          })
        ));
      }
    }), t({
      close: y,
      open: o
    }), (C, p) => ($(), H(Ue, null, [
      b(i(Re), Vt({
        modelValue: r.value,
        "onUpdate:modelValue": p[3] || (p[3] = (v) => r.value = v),
        class: "mc-login nt"
      }, a.value, {
        onShake: p[4] || (p[4] = (v) => y(!1))
      }), {
        default: w(() => [
          _("div", sa, [
            b(xt, {
              name: "form",
              tag: "div",
              class: "mc-login__forms"
            }, {
              default: w(() => [
                b(na, {
                  key: "register",
                  form: n.value,
                  "onUpdate:form": p[0] || (p[0] = (v) => n.value = v),
                  onSuccess: u,
                  onClose: p[1] || (p[1] = (v) => y(!1))
                }, null, 8, ["form"])
              ]),
              _: 1
            }),
            b(i(Y), {
              class: "mc-close-icon",
              icon: "close",
              flat: "",
              round: "",
              dense: "",
              onClick: p[2] || (p[2] = (v) => y(!1))
            })
          ])
        ]),
        _: 1
      }, 16, ["modelValue"]),
      b(i(Re), {
        modelValue: l.value,
        "onUpdate:modelValue": p[5] || (p[5] = (v) => l.value = v),
        persistent: "",
        class: "success-dialog"
      }, {
        default: w(() => [
          b(i(no), { class: "success-card" }, {
            default: w(() => [
              b(i(Y), {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                class: "success-close-btn",
                onClick: d
              }),
              b(i(so), { class: "success-content text-center" }, {
                default: w(() => [
                  p[7] || (p[7] = _("div", { class: "success-title" }, " Earn points on this purchase ", -1)),
                  _("div", aa, [
                    p[6] || (p[6] = _("img", {
                      src: Ws,
                      alt: "",
                      class: "success-icon"
                    }, null, -1)),
                    _("div", ra, q(c.status === "success" ? "Sign-up successful!" : c.status === "notActivated" ? "Your account has not been created/activated!" : "You're already a Cozy Club member!"), 1)
                  ]),
                  _("div", ia, q(c.status === "success" ? "An initial password has been sent to your email. Check your inbox to view your points balance." : c.status === "notActivated" ? "Please register or check your activation email." : "your points will be automatically added after each purchase."), 1),
                  c.status === "success" ? ($(), F(i(Y), {
                    key: 0,
                    unelevated: "",
                    color: "dark",
                    label: "OK",
                    class: "confirm-btn",
                    onClick: d
                  })) : ne("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64));
  }
}, ca = /* @__PURE__ */ oe(la, [["__scopeId", "data-v-7cc2be26"]]), to = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='common_icons_miniprogram'%3e%3cpath%20id='Oval%2078'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24%2048C10.7452%2048%200%2037.2548%200%2024C0%2010.7452%2010.7452%200%2024%200C37.2548%200%2048%2010.7452%2048%2024C48%2037.2548%2037.2548%2048%2024%2048Z'%20fill='%2307C160'/%3e%3cpath%20id='Combined%20Shape'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.1763%2029.1337L34.6146%2015.6953L37.1647%2018.2454L22.8793%2032.5249C21.9417%2033.462%2020.4219%2033.4616%2019.4849%2032.5239L12%2025.0336L14.5381%2022.4955L21.1763%2029.1337Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", ua = { class: "diaglog-content" }, da = {
  key: 1,
  class: "text-btn"
}, fa = { class: "btn-group" }, pa = {
  __name: "thirdLoginCompleteInfo",
  setup(e, { expose: t }) {
    const s = pe(), a = T(!1), r = T(!1), l = T(null), c = T(null), n = T({
      email: "",
      code: ""
    }), u = T({}), d = T(!1), o = T({}), y = we({
      email: [
        (E) => E && E.length > 0 || "Email is required.",
        (E, S) => S.email(E) || "Please enter your correct email address"
      ],
      code: [(E) => !!E || "Please enter correct code"]
    });
    let C = null;
    const p = T(60), v = T(!1), x = T(!1);
    function N(E, S) {
      let D;
      return function(...z) {
        clearTimeout(D), D = setTimeout(() => E.apply(this, z), S);
      };
    }
    const R = N(async () => {
      if (p.value = 60, !await l.value.validate())
        return;
      const S = await Zn({
        email: n.value.email,
        sid: o.value.sid,
        type: 6
      });
      Reflect.has(S, "status") && (v.value = !0, x.value = !1, C = setInterval(() => {
        p.value--, p.value === 0 && (clearInterval(C), v.value = !1);
      }, 1e3), S?.status === 11 && (x.value = !0, s.notify({
        message: "The session has expired and needs to be restarted",
        color: "negative",
        position: "top",
        timeout: 3e3
      })));
    }, 300);
    async function O() {
      await l.value.validate() && R();
    }
    async function j() {
      if (d.value)
        document.dispatchEvent(
          new Me({
            type: "assembly-login",
            ...u.value,
            sid: o.value.sid,
            platform: o.value.platform
          })
        ), a.value = !1;
      else {
        if (!await c.value.validate())
          return;
        r.value = !0;
        try {
          let S = await Qn({
            code: n.value.code,
            sid: o.value.sid
          });
          S = S || {}, u.value = S, S?.status === 11 ? s.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : S?.status === 12 ? s.notify({
            message: "Please enter the correct verification code",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Reflect.has(S, "status") && (S.token && ut(S.token), d.value = !0);
        } catch (S) {
          console.error("Verify mail code failed:", S);
        } finally {
          r.value = !1;
        }
      }
    }
    function V() {
      document.dispatchEvent(
        new Me({
          type: "assembly-login",
          ...u.value,
          sid: o.value.sid,
          platform: o.value.platform
        })
      ), a.value = !1;
    }
    function k(E = { sid: "", platform: "" }) {
      a.value = !0, c.value?.resetValidation(), n.value.email = "", n.value.code = "", u.value = {}, d.value = !1, v.value = !1, x.value = !1, p.value = 60, o.value = E;
    }
    return t({
      open: k
    }), (E, S) => {
      const D = G("q-space"), z = G("q-btn"), B = G("q-card-section"), W = G("q-input"), X = G("q-form"), I = G("q-card-actions"), h = G("q-card"), A = G("q-dialog"), U = Mt("close-popup");
      return $(), F(A, {
        modelValue: a.value,
        "onUpdate:modelValue": S[2] || (S[2] = (J) => a.value = J),
        persistent: "",
        onBeforeHide: V
      }, {
        default: w(() => [
          b(h, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: w(() => [
              b(B, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: w(() => [
                  b(D),
                  Ne(b(z, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [U]
                  ])
                ]),
                _: 1
              }),
              _("div", ua, [
                b(B, { class: "dialog-title" }, {
                  default: w(() => [
                    K(q(d.value ? "Registration successful" : "Create account"), 1)
                  ]),
                  _: 1
                }),
                d.value ? ($(), F(B, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: w(() => [...S[3] || (S[3] = [
                    _("img", {
                      src: to,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ne("", !0),
                b(B, { class: "dialog-des" }, {
                  default: w(() => [
                    K(q(d.value ? `You have successfully registered, and your account has been linked to ${o.value.platform}. In the future, you can log in using ${o.value.platform} or your email.` : "Please provide the missing information so we can create a Momcozy account."), 1)
                  ]),
                  _: 1
                }),
                d.value ? ne("", !0) : ($(), F(I, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: w(() => [
                    b(X, {
                      ref_key: "formRef",
                      ref: c,
                      class: "full-width",
                      onSubmit: Z(j, ["prevent"])
                    }, {
                      default: w(() => [
                        b(W, {
                          ref_key: "emailInput",
                          ref: l,
                          modelValue: n.value.email,
                          "onUpdate:modelValue": S[0] || (S[0] = (J) => n.value.email = J),
                          rules: y.email,
                          type: "text",
                          label: "* E-mail",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: w(() => [
                            v.value ? ($(), H("span", da, q(p.value), 1)) : ($(), H("span", {
                              key: 0,
                              class: "text-btn cursor-pointer",
                              onClick: O
                            }, "Get code"))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        b(W, {
                          modelValue: n.value.code,
                          "onUpdate:modelValue": S[1] || (S[1] = (J) => n.value.code = J),
                          rules: y.code,
                          type: "text",
                          class: "q-pb-lg",
                          label: "* Enter code",
                          outlined: ""
                        }, $t({ _: 2 }, [
                          v.value && !x.value ? {
                            name: "hint",
                            fn: w(() => [
                              S[4] || (S[4] = K(" A verification email has been sent to your inbox. Please check your email to verify your account. ", -1))
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1032, ["modelValue", "rules"]),
                        _("div", fa, [
                          b(z, {
                            loading: r.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                d.value ? ($(), H("div", {
                  key: 2,
                  class: Fe(["btn-group", { success: d.value }])
                }, [
                  b(z, {
                    loading: r.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: j
                  }, null, 8, ["loading"])
                ], 2)) : ne("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, ma = /* @__PURE__ */ oe(pa, [["__scopeId", "data-v-68fdc9dc"]]), va = { class: "diaglog-content" }, ga = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ya = {
  key: 1,
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ha = { style: { "margin-top": "0", display: "flex", "justify-content": "flex-end", "align-items": "center" } }, wa = ["href"], ba = { class: "btn-group" }, _a = {
  __name: "thirdVerifyPassword",
  setup(e, { expose: t }) {
    const s = pe(), { t: a } = fe(), r = T(!1), l = T(!1), c = T(null), n = T({
      password: ""
    }), u = T({}), d = T(!1), o = T("password"), y = T({}), C = we({
      password: [(N) => !!N || "Please enter your password"]
    });
    function p() {
      document.dispatchEvent(
        new Me({
          type: "assembly-login",
          ...u.value,
          sid: y.value.sid,
          platform: y.value.platform
        })
      ), r.value = !1;
    }
    async function v() {
      if (d.value)
        document.dispatchEvent(
          new Me({
            type: "assembly-login",
            ...u.value,
            sid: y.value.sid,
            platform: y.value.platform
          })
        ), r.value = !1;
      else {
        if (!await c.value.validate())
          return;
        const R = De(n.value.password);
        try {
          const O = await zn({
            password: R,
            sid: y.value.sid
          }).finally(() => {
            l.value = !1;
          });
          u.value = O ? { ...O } : {}, u.value?.status === 11 ? s.notify({
            message: "The session has expired and needs to be restarted",
            color: "negative",
            position: "center",
            timeout: 3e3
          }) : Object.prototype.hasOwnProperty.call(u.value, "status") && (O.token && ut(O.token), d.value = !0);
        } catch {
          l.value = !1;
        }
      }
    }
    function x(N = { sid: "", platform: "", email: "" }) {
      r.value = !0, c.value?.resetValidation(), n.value.password = "", u.value = {}, d.value = !1, y.value = N;
    }
    return t({
      open: x
    }), (N, R) => {
      const O = G("q-space"), j = G("q-btn"), V = G("q-card-section"), k = G("svg-icon"), E = G("q-input"), S = G("q-form"), D = G("q-card-actions"), z = G("q-card"), B = G("q-dialog"), W = Mt("close-popup");
      return $(), F(B, {
        modelValue: r.value,
        "onUpdate:modelValue": R[3] || (R[3] = (X) => r.value = X),
        persistent: "",
        onBeforeHide: p
      }, {
        default: w(() => [
          b(z, { style: { "max-width": "600px", "overflow-x": "hidden" } }, {
            default: w(() => [
              b(V, { class: "row items-center q-pb-none q-pt-lg" }, {
                default: w(() => [
                  b(O),
                  Ne(b(j, {
                    icon: "close",
                    flat: "",
                    round: "",
                    dense: ""
                  }, null, 512), [
                    [W]
                  ])
                ]),
                _: 1
              }),
              _("div", va, [
                b(V, { class: "dialog-title" }, {
                  default: w(() => [
                    K(q(d.value ? "Login successful" : "Verify password"), 1)
                  ]),
                  _: 1
                }),
                d.value ? ($(), F(V, {
                  key: 0,
                  class: "row justify-center items-center q-py-none q-px-none q-pb-lg"
                }, {
                  default: w(() => [...R[4] || (R[4] = [
                    _("img", {
                      src: to,
                      alt: "",
                      srcset: "",
                      style: { width: "48px", height: "48px" }
                    }, null, -1)
                  ])]),
                  _: 1
                })) : ne("", !0),
                b(V, { class: "dialog-des" }, {
                  default: w(() => [
                    K(q(d.value ? `You have successfully logged in, and your account has been linked to ${y.value.platform}. In the future, you can log in using ${y.value.platform} or your email.` : `The email ${y.value.email} is already registered with Momcozy. Is this the email you are using? If so,
          please enter your Momcozy account password to link your ${y.value.platform} account.`), 1)
                  ]),
                  _: 1
                }),
                d.value ? ne("", !0) : ($(), F(D, {
                  key: 1,
                  class: "text-center q-pa-none"
                }, {
                  default: w(() => [
                    b(S, {
                      ref_key: "formRef",
                      ref: c,
                      class: "full-width",
                      onSubmit: Z(v, ["prevent"])
                    }, {
                      default: w(() => [
                        b(E, {
                          modelValue: n.value.password,
                          "onUpdate:modelValue": R[2] || (R[2] = (X) => n.value.password = X),
                          rules: C.password,
                          type: o.value,
                          label: "* Password",
                          class: "q-pb-lg",
                          outlined: ""
                        }, {
                          append: w(() => [
                            b(k, {
                              class: "cursor-pointer",
                              name: o.value === "password" ? "hide_password" : "show_password",
                              onClick: R[0] || (R[0] = (X) => o.value = o.value === "password" ? "text" : "password")
                            }, null, 8, ["name"]),
                            _("span", {
                              class: "cursor-pointer",
                              onClick: R[1] || (R[1] = (X) => o.value = o.value === "password" ? "text" : "password")
                            }, [
                              o.value === "password" ? ($(), H("svg", ga, [...R[5] || (R[5] = [
                                _("g", { id: "Frame" }, [
                                  _("path", {
                                    id: "Ellipse 79",
                                    d: "M13.907 5C12.4401 6.66563 10.2728 7.71945 7.85489 7.71945C5.43701 7.71945 3.26966 6.66563 1.80273 5",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3",
                                    "stroke-linecap": "round"
                                  }),
                                  _("path", {
                                    id: "Vector 8",
                                    d: "M7.35 11.5C7.35 11.859 7.64101 12.15 8 12.15C8.35899 12.15 8.65 11.859 8.65 11.5H7.35ZM8.65 8.5V7.85H7.35V8.5H8.65ZM8.65 11.5V8.5H7.35V11.5H8.65Z",
                                    fill: "#97999B"
                                  }),
                                  _("path", {
                                    id: "Vector 9",
                                    d: "M12.9371 10.9231C13.1166 11.234 13.5141 11.3405 13.825 11.161C14.1359 10.9815 14.2424 10.584 14.0629 10.2731L12.9371 10.9231ZM12.5629 7.675L12.2379 7.11208L11.1121 7.76208L11.4371 8.325L12.5629 7.675ZM14.0629 10.2731L12.5629 7.675L11.4371 8.325L12.9371 10.9231L14.0629 10.2731Z",
                                    fill: "#97999B"
                                  }),
                                  _("path", {
                                    id: "Vector 10",
                                    d: "M2.81292 10.9231C2.63342 11.234 2.23589 11.3405 1.925 11.161C1.61411 10.9815 1.50759 10.584 1.68708 10.2731L2.81292 10.9231ZM3.18708 7.675L3.51208 7.11208L4.63792 7.76208L4.31292 8.325L3.18708 7.675ZM1.68708 10.2731L3.18708 7.675L4.31292 8.325L2.81292 10.9231L1.68708 10.2731Z",
                                    fill: "#97999B"
                                  })
                                ], -1)
                              ])])) : ($(), H("svg", ya, [...R[6] || (R[6] = [
                                _("g", {
                                  id: "Frame",
                                  "clip-path": "url(#clip0_1844_7198)"
                                }, [
                                  _("g", { id: "Intersect" }, [
                                    _("mask", {
                                      id: "path-1-inside-1_1844_7198",
                                      fill: "white"
                                    }, [
                                      _("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M0.498047 8.76838C1.30429 4.69775 4.95296 1.625 9.33212 1.625C13.7193 1.625 17.3733 4.709 18.1706 8.79073C17.3644 12.8614 13.7157 15.9341 9.33652 15.9341C4.94934 15.9341 1.29534 12.8501 0.498047 8.76838Z"
                                      })
                                    ]),
                                    _("path", {
                                      d: "M0.498047 8.76838L-0.777181 8.51581L-0.826862 8.76664L-0.77784 9.0176L0.498047 8.76838ZM18.1706 8.79073L19.4458 9.0433L19.4955 8.79247L19.4465 8.54151L18.1706 8.79073ZM1.77327 9.02096C2.45817 5.56296 5.5696 2.925 9.33212 2.925V0.325C4.33631 0.325 0.150401 3.83254 -0.777181 8.51581L1.77327 9.02096ZM9.33212 2.925C13.1016 2.925 16.2174 5.57264 16.8947 9.03995L19.4465 8.54151C18.5292 3.84537 14.337 0.325 9.33212 0.325V2.925ZM16.8954 8.53815C16.2105 11.9961 13.099 14.6341 9.33652 14.6341V17.2341C14.3323 17.2341 18.5182 13.7266 19.4458 9.0433L16.8954 8.53815ZM9.33652 14.6341C5.56707 14.6341 2.45121 11.9865 1.77393 8.51916L-0.77784 9.0176C0.139468 13.7137 4.33161 17.2341 9.33652 17.2341V14.6341Z",
                                      fill: "#97999B",
                                      mask: "url(#path-1-inside-1_1844_7198)"
                                    })
                                  ]),
                                  _("circle", {
                                    id: "Ellipse 77",
                                    cx: "9.5",
                                    cy: "8.82617",
                                    r: "2.725",
                                    stroke: "#97999B",
                                    "stroke-width": "1.3"
                                  })
                                ], -1),
                                _("defs", null, [
                                  _("clipPath", { id: "clip0_1844_7198" }, [
                                    _("rect", {
                                      width: "18",
                                      height: "18",
                                      fill: "white",
                                      transform: "translate(0.5 0.5)"
                                    })
                                  ])
                                ], -1)
                              ])]))
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules", "type"]),
                        _("div", ha, [
                          _("a", {
                            href: i(eo),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "aria-label": "forget password (opens in a new tab)",
                            "aria-describedby": "a11y-new-window-message"
                          }, q(i(a)("login.actions.forgotPassword")), 9, wa)
                        ]),
                        _("div", ba, [
                          b(j, {
                            loading: l.value,
                            size: "lg",
                            class: "full-width",
                            label: "Confirm",
                            type: "submit",
                            color: "dark"
                          }, null, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })),
                d.value ? ($(), H("div", {
                  key: 2,
                  class: Fe(["btn-group", { success: d.value }])
                }, [
                  b(j, {
                    loading: l.value,
                    size: "lg",
                    class: "full-width",
                    label: "Confirm",
                    type: "submit",
                    color: "dark",
                    onClick: v
                  }, null, 8, ["loading"])
                ], 2)) : ne("", !0)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, Ca = /* @__PURE__ */ oe(_a, [["__scopeId", "data-v-c2f9d40a"]]);
(function(e) {
  if (typeof e > "u")
    throw new Error("Geetest requires browser environment");
  var t = e.document, s = e.Math, a = t.getElementsByTagName("head")[0], r = 1e4;
  function l(f) {
    this._obj = f;
  }
  l.prototype = {
    _each: function(f) {
      var L = this._obj;
      for (var m in L)
        L.hasOwnProperty(m) && f(m, L[m]);
      return this;
    },
    _extend: function(f) {
      var L = this;
      new l(f)._each(function(m, g) {
        L._obj[m] = g;
      });
    }
  };
  var c = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(f) {
      var L = s.random() * 16 | 0, m = f === "x" ? L : L & 3 | 8;
      return m.toString(16);
    });
  };
  function n(f) {
    var L = this;
    new l(f)._each(function(m, g) {
      L[m] = g;
    });
  }
  n.prototype = {
    apiServers: ["gcaptcha4.geetest.com", "gcaptcha4.geevisit.com", "gcaptcha4.gsensebot.com"],
    staticServers: ["static.geetest.com", "static.geevisit.com"],
    protocol: "http://",
    typePath: "/load",
    fallback_config: {
      bypass: {
        staticServers: ["static.geetest.com", "static.geevisit.com"],
        type: "bypass",
        bypass: "/v4/bypass.js"
      }
    },
    _get_fallback_config: function() {
      var f = this;
      return d(f.type) ? f.fallback_config[f.type] : f.fallback_config.bypass;
    },
    _extend: function(f) {
      var L = this;
      new l(f)._each(function(m, g) {
        L[m] = g;
      });
    }
  };
  var u = function(f) {
    return typeof f == "number";
  }, d = function(f) {
    return typeof f == "string";
  }, o = function(f) {
    return typeof f == "boolean";
  }, y = function(f) {
    return typeof f == "object" && f !== null;
  }, C = function(f) {
    return typeof f == "function";
  }, p = /Mobi/i.test(navigator.userAgent), v = {}, x = {}, N = function() {
    return parseInt(s.random() * 1e4) + (/* @__PURE__ */ new Date()).valueOf();
  }, R = function(f, L) {
    if (typeof f == "function") {
      var m = Array.prototype.slice.call(arguments, 2);
      return Function.prototype.bind ? f.bind(L, m) : function() {
        var g = Array.prototype.slice.call(arguments);
        return f.apply(L, m.concat(g));
      };
    }
  }, O = Object.prototype.toString, j = function(f) {
    return typeof f == "function";
  }, V = function(f) {
    return f === Object(f);
  }, k = function(f) {
    return O.call(f) == "[object Array]";
  }, E = function(f) {
    return O.call(f) == "[object Date]";
  }, S = function(f) {
    return O.call(f) == "[object RegExp]";
  }, D = function(f) {
    return O.call(f) == "[object Boolean]";
  };
  function z(f) {
    return f.replace(/(\S)(_([a-zA-Z]))/g, function(L, m, g, P) {
      return m + P.toUpperCase() || "";
    });
  }
  function B(f, L) {
    if (!V(f) || E(f) || S(f) || D(f) || j(f))
      return L ? z(f) : f;
    if (k(f))
      for (var m = [], g = 0; g < f.length; g++)
        m.push(B(f[g]));
    else {
      var m = {};
      for (var P in f)
        f.hasOwnProperty(P) && (m[B(P, !0)] = B(f[P]));
    }
    return m;
  }
  var W = function(f, L, m) {
    var g = t.createElement("script");
    g.charset = "UTF-8", g.async = !0, /static\.geetest\.com/g.test(f) && (g.crossOrigin = "anonymous"), g.onerror = function() {
      L(!0), P = !0;
    };
    var P = !1;
    g.onload = g.onreadystatechange = function() {
      !P && (!g.readyState || g.readyState === "loaded" || g.readyState === "complete") && (P = !0, setTimeout(function() {
        L(!1);
      }, 0));
    }, g.src = f, a.appendChild(g), setTimeout(function() {
      P || (g.onerror = g.onload = null, g.remove && g.remove(), L(!0));
    }, m || r);
  }, X = function(f) {
    return f.replace(/^https?:\/\/|\/$/g, "");
  }, I = function(f) {
    return f = f && f.replace(/\/+/g, "/"), f.indexOf("/") !== 0 && (f = "/" + f), f;
  }, h = function(f) {
    if (!f)
      return "";
    var L = "?";
    return new l(f)._each(function(m, g) {
      (d(g) || u(g) || o(g)) && (L = L + encodeURIComponent(m) + "=" + encodeURIComponent(g) + "&");
    }), L === "?" && (L = ""), L.replace(/&$/, "");
  }, A = function(f, L, m, g) {
    L = X(L);
    var P = I(m) + h(g);
    return L && (P = f + L + P), P;
  }, U = function(f, L, m, g, P, M, ee) {
    var le = function(ae) {
      if (ee) {
        var re = "geetest_" + N();
        e[re] = R(ee, null, re), P.callback = re;
      }
      var ve = A(L, m[ae], g, P);
      W(ve, function(Xe) {
        if (Xe) {
          if (re)
            try {
              e[re] = function() {
                e[re] = null;
              };
            } catch {
            }
          ae >= m.length - 1 ? M(!0) : le(ae + 1);
        } else
          M(!1);
      }, f.timeout);
    };
    le(0);
  }, J = function(f, L, m, g) {
    var P = function(M, ee) {
      ee.status == "success" ? g(ee.data) : (ee.status, g(ee)), e[M] = void 0;
      try {
        delete e[M];
      } catch {
      }
    };
    U(m, m.protocol, f, L, {
      callback: "",
      captcha_id: m.captchaId,
      challenge: m.challenge || c(),
      client_type: m.clientType ? m.clientType : p ? "h5" : "web",
      risk_type: m.riskType,
      user_info: m.userInfo,
      call_type: m.callType,
      lang: m.language ? m.language : navigator.appName === "Netscape" ? navigator.language.toLowerCase() : navigator.userLanguage.toLowerCase()
    }, function(M) {
      if (M && typeof m.offlineCb == "function") {
        m.offlineCb();
        return;
      }
      M && g(m._get_fallback_config());
    }, P);
  }, se = function(f, L, m) {
    var g = {
      networkError: "缃戠粶閿欒",
      gtTypeError: "gt瀛楁涓嶆槸瀛楃涓茬被鍨�"
    };
    if (typeof L.onError == "function")
      L.onError({
        desc: m.desc,
        msg: m.msg,
        code: m.code
      });
    else
      throw new Error(g[f]);
  }, Qe = function() {
    return e.Geetest || t.getElementById("gt_lib");
  };
  Qe() && (x.slide = "loaded");
  var ze = function(f) {
    var L = !1, m = { js: "script", css: "link" }, g = f && m[f.split(".").pop()];
    if (g !== void 0) {
      var P = t.getElementsByTagName(g);
      for (var M in P)
        (P[M].href && P[M].href.toString().indexOf(f) > 0 || P[M].src && P[M].src.toString().indexOf(f) > 0) && (L = !0);
    }
    return L;
  };
  e.initGeetest4 = function(f, L) {
    var m = new n(f);
    f.https ? m.protocol = "https://" : f.protocol || (m.protocol = e.location.protocol + "//"), y(f.getType) && m._extend(f.getType), J(m.apiServers, m.typePath, m, function(P) {
      var P = B(P);
      if (P.status === "error")
        return se("networkError", m, P);
      var M = P.type;
      m.debug && new l(P)._extend(m.debug);
      var ee = function() {
        m._extend(P), L(new e.Geetest4(m));
      };
      v[M] = v[M] || [];
      var le = x[M] || "init";
      if (le === "init")
        x[M] = "loading", v[M].push(ee), P.gctPath && U(m, m.protocol, Object.hasOwnProperty.call(m, "staticServers") ? m.staticServers : P.staticServers || m.staticServers, P.gctPath, null, function(ae) {
          ae && se("networkError", m, {
            code: "60205",
            msg: "Network failure",
            desc: {
              detail: "gct resource load timeout"
            }
          });
        }), U(m, m.protocol, Object.hasOwnProperty.call(m, "staticServers") ? m.staticServers : P.staticServers || m.staticServers, P.bypass || P.staticPath + P.js, null, function(ae) {
          if (ae)
            x[M] = "fail", se("networkError", m, {
              code: "60204",
              msg: "Network failure",
              desc: {
                detail: "js resource load timeout"
              }
            });
          else {
            x[M] = "loaded";
            for (var re = v[M], ve = 0, Xe = re.length; ve < Xe; ve = ve + 1) {
              var Ye = re[ve];
              C(Ye) && Ye();
            }
            v[M] = [], x[M] = "init";
          }
        });
      else {
        if (le === "loaded")
          return P.gctPath && !ze(P.gctPath) && U(m, m.protocol, Object.hasOwnProperty.call(m, "staticServers") ? m.staticServers : P.staticServers || m.staticServers, P.gctPath, null, function(ae) {
            ae && se("networkError", m, {
              code: "60205",
              msg: "Network failure",
              desc: {
                detail: "gct resource load timeout"
              }
            });
          }), ee();
        le === "fail" ? se("networkError", m, {
          code: "60204",
          msg: "Network failure",
          desc: {
            detail: "js resource load timeout"
          }
        }) : le === "loading" && v[M].push(ee);
      }
    });
  };
})(window);
const Ze = ao || globalThis.Quasar, Te = Symbol.for("login-element-instance"), Le = Symbol.for("third-verify-password-element-instance"), $e = Symbol.for("third-login-complete-info-element-instance"), Pe = Symbol.for("quick-register-member-element-instance"), ka = Be(Ks, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: _e,
        Loading: it
      }
    }), e.provide(je, de), e.use(de);
  }
});
class Ea extends ka {
  connectedCallback() {
    const t = window[Te];
    t && t !== this && document.contains(t) && this.remove(), window[Te] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Te] === this && (window[Te] = null), super.disconnectedCallback();
  }
}
customElements.get("login-dialog") || customElements.define("login-dialog", Ea);
const Sa = Be(Ca, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: _e,
        Loading: it
      }
    }), e.provide(je, de), e.use(de);
  }
});
class Ta extends Sa {
  connectedCallback() {
    const t = window[Le];
    t && t !== this && document.contains(t) && this.remove(), window[Le] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Le] === this && (window[Le] = null), super.disconnectedCallback();
  }
}
customElements.get("third-verify-password-dialog") || customElements.define("third-verify-password-dialog", Ta);
const La = Be(ma, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: _e,
        Loading: it
      }
    }), e.provide(je, de), e.use(de);
  }
});
class $a extends La {
  connectedCallback() {
    const t = window[$e];
    t && t !== this && document.contains(t) && this.remove(), window[$e] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[$e] === this && (window[$e] = null), super.disconnectedCallback();
  }
}
customElements.get("third-login-complete-info-dialog") || customElements.define("third-login-complete-info-dialog", $a);
const Pa = Be(ca, {
  configureApp(e) {
    e.use(Ze, {
      config: {
        brand: {
          primary: "#6f3b49",
          positive: "#71BF89",
          dark: "#1F1F20",
          negative: "#FA5151"
        },
        globalNodes: {
          class: "quasar"
        }
      },
      plugins: {
        Notify: _e
      }
    }), e.provide(je, de), e.use(de);
  }
});
class Ra extends Pa {
  connectedCallback() {
    const t = window[Pe];
    t && t !== this && document.contains(t) && this.remove(), window[Pe] = this, super.connectedCallback();
  }
  disconnectedCallback() {
    window[Pe] === this && (window[Pe] = null), super.disconnectedCallback();
  }
}
customElements.get("quick-register-member-dialog") || customElements.define("quick-register-member-dialog", Ra);
